module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    attrs: {
      "id": "Letter_A"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/toc"
    }
  }, [_vm._v("A")])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse",
    attrs: {
      "id": "P0001"
    }
  }, [_c('strong', [_vm._v("a posteriori, a priori.")]), _vm._v(" Terms used to describe the logical status of propositions and arguments with respect to their dependence upon, or independence from, sense experience. An a posteriori proposition is one that is known on the basis of sense experience. An a priori proposition is one that can be determined to be true independently of sense experience. Most philosophers agree that analytic propositions such as “All bachelors are unmarried” can be known a priori, because their truth cannot be affected by any empirical observations. However, the status of mathematical and metaphysical propositions (such as “Whatever has a beginning has a cause”) is debated.")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0002"
    }
  }, [_c('strong', [_vm._v("Abelard, Peter (1079-1142).")]), _vm._v(" French Scholastic philosopher and theologian who made important contributions to logic and philosophy of language, and offered notable explications of such Christian doctrines as the "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0410",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Trinity")]), _vm._v(" and the "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0026"
    }
  }, [_vm._v("atonement")]), _vm._v(". Abelard is also famous for a celebrated, tragic love affair with Héloïse (c. 1117). He was the first Western medieval philosopher to make use of "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0022"
    }
  }, [_vm._v("Aristotle’s")]), _vm._v(" "), _c('em', [_vm._v("On Interpretation.")])]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0003"
    }
  }, [_c('strong', [_vm._v("action (divine and human).")]), _vm._v(" A special type of event originated by persons understood as “agents,” that is, conscious beings with intentions. Thus, when the event that constitutes my arm being raised is brought about by my raising my arm, the change constitutes an act or action. (Having one’s arm raised against one’s will by a rope attached to it would not constitute an action.) Many actions are performed by doing other actions. For example, I turn on the light by flipping the switch. However, not all actions are of this sort; some are “basic actions,” since if I must always perform one action to carry out another, an infinite regress would ensue. Philosophers debate whether basic actions are a type of bodily movement or whether such bodily movements are the result of something still more basic—a volition or mental act of willing. Actions are typically done for a reason, and there is also controversy as to how actions are to be explained. Are reasons to be understood as causes? Debate also rages as to whether all actions are causally determined. ("), _c('em', [_vm._v("See")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0101"
    }
  }, [_vm._v("determinism")]), _vm._v("; "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0151"
    }
  }, [_vm._v("free will")]), _vm._v(".) To think of God as a personal agent is to attribute to God the power to act as well. Debates here link up with disputes about whether God is atemporal or everlasting; does God do all he does in one eternal action, or is he capable of sequential acts? "), _c('em', [_vm._v("(See")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0129"
    }
  }, [_vm._v("eternity/everlasting")]), _vm._v(".) How are God’s actions related to the divine will and intellect? God’s actions must be understood in relation to "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0082"
    }
  }, [_vm._v("creation")]), _vm._v(" and "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0330",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("providence")]), _vm._v(" and in connection with special acts such as "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0252",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("miracles")]), _vm._v(". "), _c('em', [_vm._v("See also")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0106"
    }
  }, [_vm._v("divine action")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0004"
    }
  }, [_c('strong', [_vm._v("Advaita Vedanta.")]), _vm._v(" A nondualistic form of Hindu theology, or Vedanta. According to Advaita Vedanta, ultimate reality is one—the absolute divine unity of Brahman that is beyond description in language. The human soul, or Atman, is identical with this absolute reality, and enlightenment or deliverance involves a realization of this oneness. At the level of appearance, objects in the world seem to be distinct from such things as the self and a personal deity. According to Advaita Vedanta, the sacred Hindu writings the Upanishads teach that such distinctions are not metaphysically ultimate. "), _c('em', [_vm._v("See also")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0175"
    }
  }, [_vm._v("Hinduism")]), _vm._v("; "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0256",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("monism")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0005"
    }
  }, [_c('strong', [_vm._v("afterlife.")]), _vm._v(" "), _c('em', [_vm._v("See")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0231"
    }
  }, [_vm._v("life after death")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0006"
    }
  }, [_c('strong', [_vm._v("agapism.")]), _vm._v(" A type of ethical tradition that centers on the Christian understanding of "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0235"
    }
  }, [_vm._v("love")]), _vm._v(" as "), _c('em', [_vm._v("agape")]), _vm._v(" (self-giving love of the “neighbor”) in distinction from "), _c('em', [_vm._v("philia")]), _vm._v(" (friendship love) and "), _c('em', [_vm._v("eros")]), _vm._v(" (love involving desire, such as romantic love). Agapism focuses on the great love commandments of Matthew 22:37-40 as well as the centrality of love in other New Testament writings. Though there is a long tradition of Christian reflection on this theme, Anders Nygren’s "), _c('em', [_vm._v("Agape and Eros")]), _vm._v(" (1930) is a seminal, though much-criticized, twentieth-century presentation of agapism in "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0130"
    }
  }, [_vm._v("ethics")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0007"
    }
  }, [_c('strong', [_vm._v("agnosticism.")]), _vm._v(" The position that neither affirms belief in God ("), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0393",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("theism")]), _vm._v(") nor denies the existence of God ("), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0025"
    }
  }, [_vm._v("atheism")]), _vm._v(") but instead suspends judgment. It is helpful to distinguish the “modest agnostic,” who merely claims to be unable to decide the question of God’s reality, from the “aggressive agnostic,” who claims that no one can decide the question and that suspension of judgment is the only reasonable stance. "), _c('em', [_vm._v("See also")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0037"
    }
  }, [_vm._v("belief")]), _vm._v("; "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0112"
    }
  }, [_vm._v("doubt")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0008"
    }
  }, [_c('strong', [_vm._v("Alston, William (1921-2009).")]), _vm._v(" North American Christian philosopher who has done important work in "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0124"
    }
  }, [_vm._v("epistemology")]), _vm._v(", philosophy of language, philosophy of perception and "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0312",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("philosophy of religion")]), _vm._v(". Alston was part of the group (along with Alvin "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0314",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Plantinga")]), _vm._v(" and Nicholas "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0426",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wolterstorff")]), _vm._v(") that developed "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0339",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Reformed Epistemology")]), _vm._v(". He was also the prime mover behind the founding of the Society of Christian Philosophers. He served as the first president of that organization as well as the first editor of its journal, "), _c('em', [_vm._v("Faith and Philosophy.")])]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0009"
    }
  }, [_c('strong', [_vm._v("analogical predication.")]), _vm._v(" Language used to describe God that is between "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0413",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("univocal")]), _vm._v(" language, in which terms applied to two or more objects have precisely the same sense, and "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0125"
    }
  }, [_vm._v("equivocal")]), _vm._v(" language, in which the same term is applied to two or more things in completely unrelated senses. Philosophers such as Thomas "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0020"
    }
  }, [_vm._v("Aquinas")]), _vm._v(" have claimed that positive language derived from our experience of the finite world cannot be applied univocally to God but that terms such as “goodness” and “knowledge” can be applied analogically to God, meaning that God possesses in an unrestricted fashion the perfections the terms designate.")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0010"
    }
  }, [_c('strong', [_vm._v("analogy of being.")]), _vm._v(" The view that, though God is infinite and the created world is finite, the being of the world reflects enough of its Creator so that the language used to describe it can be applied analogically to God. This view is usually associated with philosophical arguments for the existence of God. ("), _c('em', [_vm._v("See")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0394",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("theistic arguments")]), _vm._v(".) The analogical similarity is usually thought to be particularly valid for human beings since they are created in the "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0190"
    }
  }, [_vm._v("image of God")]), _vm._v(". The analogy of being has been rejected by Karl "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0033"
    }
  }, [_vm._v("Barth")]), _vm._v(" and others who are critical of "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0264",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("natural theology")]), _vm._v(". "), _c('em', [_vm._v("See also")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0009"
    }
  }, [_vm._v("analogical predication")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0011"
    }
  }, [_c('strong', [_vm._v("analogy of faith.")]), _vm._v(" The view that interpretation of the Scriptures should be governed by "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0139"
    }
  }, [_vm._v("faith")]), _vm._v(". For "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0028"
    }
  }, [_vm._v("Augustine")]), _vm._v(", this meant that the Scriptures should be interpreted in terms of the “rule of faith”—the teachings of the church as embedded in the creeds. For Martin "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0236"
    }
  }, [_vm._v("Luther")]), _vm._v(", the analogy of faith was linked to the person of Christ—specifically, all of Scripture should be interpreted as testifying to Christ. For John "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0047"
    }
  }, [_vm._v("Calvin")]), _vm._v(", the principle implied that interpretation must be shaped by the Spirit who inspired the writing of the Scriptures. In all these cases, some parts of the Scriptures are regarded as clearer and more definitive than others and are to be used to interpret those less clear passages. "), _c('em', [_vm._v("See also")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0172"
    }
  }, [_vm._v("hermeneutics")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0012"
    }
  }, [_c('strong', [_vm._v("analytic philosophy.")]), _vm._v(" The type of "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0311",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("philosophy")]), _vm._v(" that has been dominant in England since about 1930 and in North America since World War II. Influential early analytic philosophers included Bertrand "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0353",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Russell")]), _vm._v(" and Ludwig "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0425",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wittgenstein")]), _vm._v(". Analytic philosophers have no shared body of philosophical views but are distinguished by a style of philosophizing that emphasizes precise language analysis and the use of logical techniques to analyze arguments. ("), _c('em', [_vm._v("see")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0233"
    }
  }, [_vm._v("logical positivism")]), _vm._v(".) Analytic philosophy of religion includes vigorous debates about the existence of God, the problem of "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0133"
    }
  }, [_vm._v("evil")]), _vm._v(", the evidential value of "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0344",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("religious experience")]), _vm._v(" and even such specific Christian doctrines as the "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0410",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Trinity")]), _vm._v(", the "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0195"
    }
  }, [_vm._v("incarnation")]), _vm._v(" and the "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0026"
    }
  }, [_vm._v("atonement")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0013"
    }
  }, [_c('strong', [_vm._v("angels.")]), _vm._v(" Powerful spiritual creatures who serve as messengers and agents of God. Though angels may take bodily form, many philosophers who believe in their reality think of them as immaterial beings. Many who accept the reality of angels as personal beings also believe in fallen angels, or "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0094"
    }
  }, [_vm._v("demons")]), _vm._v(", who have rebelled against divine authority, with Satan as their leader.")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0014"
    }
  }, [_c('strong', [_vm._v("animism.")]), _vm._v(" A perspective on the world that sees spiritual powers or forces as residing in and controlling all of the natural world. Thus an animist would recognize not only spirits in animals and humans but also the spirits of trees, rivers and other natural entities.")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0015"
    }
  }, [_c('strong', [_vm._v("Anselm, St. (1033-1109).")]), _vm._v(" Anselm was an archbishop of Canterbury who is noted for his invention of the "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0286",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ontological argument")]), _vm._v(" for God’s existence (in his "), _c('em', [_vm._v("Proslogion")]), _vm._v(") and his classical formulation of a doctrine of the "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0026"
    }
  }, [_vm._v("atonement")]), _vm._v(" that sees Christ’s sacrifice as providing satisfaction for human "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0367",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("sin")]), _vm._v(" (in his "), _c('em', [_vm._v("Cur Deus homo,")]), _vm._v(" or "), _c('em', [_vm._v("Why God Became Man")]), _vm._v("). Anselm was a follower of "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0028"
    }
  }, [_vm._v("Augustine")]), _vm._v(" and continued the tradition of “faith seeking understanding.”")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0016"
    }
  }, [_c('strong', [_vm._v("anthropomorphism.")]), _vm._v(" The human tendency to see other things as analogous to ourselves. Thus people sometimes see their pets in overly anthropomorphic terms. In "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0312",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("philosophy of religion")]), _vm._v(", the term "), _c('em', [_vm._v("anthropomorphism")]), _vm._v(" is often used critically, to refer to views of God that make God seem too similar to finite human persons. Ludwig "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0143"
    }
  }, [_vm._v("Feuerbach")]), _vm._v(" claimed that all theology is anthropomorphic, since God is essentially a projection of unfulfilled human potential.")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0017"
    }
  }, [_c('strong', [_vm._v("antirealism.")]), _vm._v(" A philosophical theory that denies the mind-independent existence of some type of being or of being in general. The former type of antirealism may be called regional antirealism; the latter may be called global antirealism. Examples of regional antirealists would be philosophers who reject the independent reality of numbers, abstract entities in general, and unobservable theoretical entities in science. Global antirealists, influenced by Immanuel "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0217"
    }
  }, [_vm._v("Kant")]), _vm._v(", typically argue that humans cannot know reality as it is in itself, independent of our human concepts. "), _c('em', [_vm._v("See also")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0188"
    }
  }, [_vm._v("idealism")]), _vm._v("; "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0335",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("realism")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0018"
    }
  }, [_c('strong', [_vm._v("antithesis.")]), _vm._v(" A term often used in popular expositions of G. W. F. Hegel’s dialectical logic, though it was rarely used by "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0168"
    }
  }, [_vm._v("Hegel")]), _vm._v(" himself. Hegel’s dialectical logic makes heavy use of triads, in which the second element of the triad in some way undermines or negates the first element, or “thesis,” thereby becoming its “antithesis.” This opposition is in turn overcome in the third element, or “synthesis,” which is supposed to capture the truth that is one-sidedly expressed by each of the first two elements while overcoming their one-sidedness. ("), _c('em', [_vm._v("See")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0103"
    }
  }, [_vm._v("dialectic")]), _vm._v(".) The term is also used in Reformed theology by followers of the Dutch theologian and statesman Abraham Kuyper to denote the sharp opposition between patterns of thinking that are faithful to God and those that are shaped by sinful rebellion.")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0019"
    }
  }, [_c('strong', [_vm._v("apologetics.")]), _vm._v(" The rational defense of Christian faith. Historically, apologetic arguments of various types have been given: philosophical arguments for the existence of God; arguments that the existence of God is compatible with suffering and evil; historical arguments, such as arguments from "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0252",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("miracles")]), _vm._v(" and fulfilled prophecies; and arguments from "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0344",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("religious experience")]), _vm._v(", including mystical experience. ("), _c('em', [_vm._v("See")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0021"
    }
  }, [_vm._v("argument from prophecy")]), _vm._v("; "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0134"
    }
  }, [_vm._v("evil, problem of")]), _vm._v("; "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0261",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("mysticism")]), _vm._v("; "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0394",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("theistic arguments")]), _vm._v(".) Some distinguish positive apologetics, which attempts to argue for the truth of Christianity, from negative apologetics, which merely attempts to remove barriers to faith by responding to critical attacks.")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0020"
    }
  }, [_c('strong', [_vm._v("Aquinas, St. Thomas (1225-1274).")]), _vm._v(" The most famous and influential of the medieval philosopher-theologians. Aquinas is noted for his synthesis of Christian theology with the philosophy of "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0022"
    }
  }, [_vm._v("Aristotle")]), _vm._v(". His general approach is summarized in the memorable dictum that “grace presupposes nature and perfects it.” He is most famous for the Five Ways, by which he demonstrated the existence of God as the First Cause of such things as motion and design and as the "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0267",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("necessary being")]), _vm._v(" that is the cause of the contingent beings in the natural world. Aquinas’s writings contain richly developed thinking on a comprehensive set of theological and philosophical topics, including "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0130"
    }
  }, [_vm._v("ethics")]), _vm._v(" and political theory. Though Aquinas believed natural reason can prove that God exists, he did not think reason is competent to know God’s essence in this life, and he affirmed that many essential Christian beliefs must be accepted on faith because God has revealed them.")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0021"
    }
  }, [_c('strong', [_vm._v("argument from prophecy.")]), _vm._v(" A type of apologetic argument that attempts to defend the divinely inspired character of prophets (and ultimately of the Scriptures that record the prophecies) by showing that the prophets foretold events whose occurrence could not have been humanly foreseen. Thus an argument from prophecy is essentially an argument that appeals to "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0252",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("miracles")]), _vm._v(". Sometimes the argument is used in a reverse direction. The fact that the life of Jesus fulfilled certain Old Testament prophecies, for example, is cited to support the claim that Jesus really is the Messiah. Arguments from prophecy have become less popular in an age characterized by critical biblical scholarship, which in many cases claims that apparently fulfilled prophecies were written after the events prophesied occurred.")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0022"
    }
  }, [_c('strong', [_vm._v("Aristotle (384-322 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("B.C.")]), _vm._v(").")]), _vm._v(" One of the most famous philosophers of ancient Greece. Although Aristotle had been a student of "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0315",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Plato")]), _vm._v(", he rejected Plato’s doctrine of transcendent Forms in favor of the claim that universal properties exist immanently in particulars, which he saw as a synthesis of form and matter. Aristotle invented logic as a formal discipline and wrote on a wide range of topics, including "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0249",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("metaphysics")]), _vm._v(", "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0130"
    }
  }, [_vm._v("ethics")]), _vm._v(" and much that would today be classified as natural "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0359",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("science")]), _vm._v(", including biology and physics. Aristotle’s followers are sometimes called Peripatetics because of his habit of lecturing as he walked on the grounds of the Lyceum, his philosophical school in Athens. "), _c('em', [_vm._v("See also")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0311",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("philosophy")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0023"
    }
  }, [_c('strong', [_vm._v("Arminianism.")]), _vm._v(" A system of Christian doctrine inspired by the thought of Jacobus Arminius (1560-1609), a Dutch theologian and pastor. Arminius taught that God’s election for "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0354",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("salvation")]), _vm._v(" was conditional on his "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0148"
    }
  }, [_vm._v("foreknowledge")]), _vm._v(" of human free choice. Though he thought of himself as a follower of John "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0047"
    }
  }, [_vm._v("Calvin")]), _vm._v(", his views were rejected by the Reformed Synod of Dordt. The relation between human "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0151"
    }
  }, [_vm._v("free will")]), _vm._v(" and divine electing "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0164"
    }
  }, [_vm._v("grace")]), _vm._v(" is still hotly debated within many Christian denominations, with those who emphasize free will often labeled Arminians.")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0024"
    }
  }, [_c('strong', [_vm._v("aseity.")]), _vm._v(" The divine property of being completely independent of everything distinct from God himself. Everything other than God depends on God, but God depends on nothing besides himself.")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0025"
    }
  }, [_c('strong', [_vm._v("atheism.")]), _vm._v(" The philosophical position that denies the reality of the "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0161"
    }
  }, [_vm._v("God")]), _vm._v(" of "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0393",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("theism")]), _vm._v(" or other divine beings. "), _c('em', [_vm._v("See also")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0007"
    }
  }, [_vm._v("agnosticism")]), _vm._v("; "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0139"
    }
  }, [_vm._v("faith")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0026"
    }
  }, [_c('strong', [_vm._v("atonement.")]), _vm._v(" Christian doctrine that Christ has in some way solved the problems created by human sinfulness, especially the problem of alienation from God. All Christians affirm the reality of the atonement, but no one theory of atonement has found universal acceptance. The most accepted theories include moral influence theories, satisfaction theories and penal substitution theories. "), _c('em', [_vm._v("See also")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0354",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("salvation")]), _vm._v("; "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0367",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("sin")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0027"
    }
  }, [_c('strong', [_vm._v("attributes of God.")]), _vm._v(" Properties such as "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0283",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("omnipotence")]), _vm._v(" (being all-powerful), "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0285",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("omniscience")]), _vm._v(" (being all-knowing) and "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0284",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("omnipresence")]), _vm._v(" (being present everywhere) that have traditionally been ascribed to "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0161"
    }
  }, [_vm._v("God")]), _vm._v(" by theists. Since the twentieth century, some have questioned whether all of the attributes traditionally ascribed to God are coherent. Critical questions have been raised about God’s "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0194"
    }
  }, [_vm._v("impassibility")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0366",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("simplicity")]), _vm._v(" and "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0401",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("timelessness")]), _vm._v(", and about the nature of God’s "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0193"
    }
  }, [_vm._v("immutability")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0028"
    }
  }, [_c('strong', [_vm._v("Augustine, St. (354-430).")]), _vm._v(" A philosopher and theologian and the most famous and influential of the church fathers for the Latin (Western) church. After his conversion, memorably described in his "), _c('em', [_vm._v("Confessions,")]), _vm._v(" Augustine became a priest and soon a bishop in Hippo in northern Africa. His most famous writings include "), _c('em', [_vm._v("On the Trinity")]), _vm._v(" and "), _c('em', [_c('a', {
    attrs: {
      "href": "#/Text/A2L#P0059"
    }
  }, [_vm._v("City of God")]), _vm._v(",")]), _vm._v(" in which he described human history as an ongoing struggle between two kingdoms—the city of God and the city of man. Augustine is the preeminent member of the great tradition of Christian Platonism, and his thought had an enormous impact both on the Scholastics of the medieval period and on the Protestant Reformers.")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0029"
    }
  }, [_c('strong', [_vm._v("authority.")]), _vm._v(" That which merits submission or deference. There are many different kinds of authority, with some of the more important kinds being moral, political and religious authority. Religions based on a "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0378",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("special revelation")]), _vm._v(", such as Christianity and Islam, stand or fall on the basis of the authority possessed by their revelations. Christians have often disagreed strongly on the locus of authority, with Protestants affirming the authority of the Bible alone ("), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0372",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("sola Scriptura)")])]), _vm._v(" and Catholics and Orthodox Christians assigning greater weight to the church and its historical "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0404",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("traditions")]), _vm._v(". Debate has also centered around criteria for recognizing a valid authority and the relation between authority and "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0336",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("reason")]), _vm._v(". Thomas "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0020"
    }
  }, [_vm._v("Aquinas")]), _vm._v(" argued that, though reason cannot certify the content of an authoritative revelation, it can investigate the credentials of an alleged revelation to be truly from God by evidence such as "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0252",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("miracles")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0030"
    }
  }, [_c('strong', [_vm._v("autonomy.")]), _vm._v(" A key concept in the ethical theory of Immanuel "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0217"
    }
  }, [_vm._v("Kant")]), _vm._v(", who held that a genuine moral obligation must be seen as legislated by "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0336",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("reason")]), _vm._v(" and thus that a rational moral agent is himself the source of moral obligations. Kant saw an individual who behaves in accordance with morality out of a fear of punishment or desire for a reward as heteronomous, not autonomous. Some contemporary radical theologians have argued that the very existence of a Creator-God to whom human beings are responsible would be a threat to human moral autonomy, and consequently they have proposed that God be understood as a humanly invented symbol or idealization.")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0031"
    }
  }, [_c('strong', [_vm._v("Averroës (1126-1198).")]), _vm._v(" Islamic philosopher whose commentaries on "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0022"
    }
  }, [_vm._v("Aristotle")]), _vm._v(" were influential for Christian and Jewish thinkers in the Middle Ages. Averroës followed Aristotle in holding that "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0192"
    }
  }, [_vm._v("immortality")]), _vm._v(" is possessed by an impersonal intellect. Some of his Christian followers were reputed to hold to a doctrine of twofold truth whereby what is true in philosophy could be false theologically, thereby resolving the conflict between the Christian belief in a personal "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0346",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("resurrection")]), _vm._v(" and an Aristotelian view in which there is no personal immortality. "), _c('em', [_vm._v("See also")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0206"
    }
  }, [_vm._v("Islam")]), _vm._v("; "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0207"
    }
  }, [_vm._v("Islamic philosophy")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0032"
    }
  }, [_c('strong', [_vm._v("Avicenna (980-1037).")]), _vm._v(" Islamic philosopher and physician who developed a synthesis of the metaphysics of "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0022"
    }
  }, [_vm._v("Aristotle")]), _vm._v(" and "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0272",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Neo-Platonism")]), _vm._v(" with Muslim monotheism. Avicenna was the focus of an attack by theologian al-Ghazali in "), _c('em', [_vm._v("The Incoherence of the Philosophers,")]), _vm._v(" which is rooted in concerns that an affirmation of the eternality of the world and the necessity of "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0054"
    }
  }, [_vm._v("causation")]), _vm._v(" undermines the doctrines of "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0082"
    }
  }, [_vm._v("creation")]), _vm._v(" and "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0330",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("providence")]), _vm._v(". Avicenna’s works had a major influence on Muslim and Jewish philosophers and, in translation, on Western Christian philosophers as well. "), _c('em', [_vm._v("See also")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0206"
    }
  }, [_vm._v("Islam")]), _vm._v("; "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0207"
    }
  }, [_vm._v("Islamic philosophy")]), _vm._v(".")]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "Letter_B"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/toc"
    }
  }, [_vm._v("B")])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse",
    attrs: {
      "id": "P0033"
    }
  }, [_c('strong', [_vm._v("Barth, Karl (1888-1968).")]), _vm._v(" One of the most significant theologians of the twentieth century. Barth’s early commentary on "), _c('em', [_vm._v("Romans")]), _vm._v(" (1918) is widely credited with undermining liberal Protestant theology and inspiring what is sometimes called "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0271",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("neo-orthodoxy")]), _vm._v(", or dialectical theology, which emphasized the absolute qualitative difference between God and humans and the essential role of "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0348",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("revelation")]), _vm._v(" in coming to know God. A German-speaking Swiss theologian, Barth played a key role in the Confessing Church, which stood up against Adolf Hitler in the Barmen Declaration. His most comprehensive work is the multivolume "), _c('em', [_vm._v("Church Dogmatics.")])]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0034"
    }
  }, [_c('strong', [_vm._v("Beatific Vision.")]), _vm._v(" The supremely happy or blessed state in which a person enjoys a direct awareness of God. Many religious philosophers have taken the Beatific Vision to be the supreme good that all humans seek, whether they know it or not, though it is generally held that this state can normally be attained, if at all, only after death.")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0035"
    }
  }, [_c('strong', [_vm._v("beauty.")]), _vm._v(" Today thought of chiefly as a fundamental type of aesthetic value, exemplified in nature and works of art. Many medievals thought that beauty was one of the transcendental properties (along with goodness and unity) that apply to all of being. A long theological tradition, influenced by "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0315",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Plato’s")]), _vm._v(" "), _c('em', [_vm._v("Symposium,")]), _vm._v(" holds that God is the source of all beauty and can even be identified with beauty in itself. Among postmedieval thinkers, Jonathan "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0118"
    }
  }, [_vm._v("Edwards")]), _vm._v(" put great emphasis on the link between God and beauty.")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0036"
    }
  }, [_c('strong', [_vm._v("behaviorism.")]), _vm._v(" The attempt to understand human beings in terms of observable behavior. Distinctions can be made between scientific behaviorism, which is a research program in psychology that limits itself to observable environmental stimuli and behavior, and philosophical behaviorism, which attempts to understand mental states reductionistically in terms of outward behavior. A philosophical behaviorist, for example, might identify pain with a tendency to engage in characteristic types of behavior, such as grimacing or crying. Some scientific behaviorists wish to commit themselves only to methodological behaviorism as a necessary rule for science, without denying the existence of inner mental states. Behaviorism is today in decline in both psychology and philosophy with the onslaught of the cognitive revolution, though functionalists still emphasize the role of behavior and stimuli (inputs and outputs) in understanding human beings.")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0037"
    }
  }, [_c('strong', [_vm._v("belief.")]), _vm._v(" The fundamental positive cognitive attitude that commonly takes a proposition as its object. Most philosophers hold that propositional beliefs can be occurrent, in which case there is conscious assent to a proposition, or nonoccurrent, in which case a person has a disposition to assent to a proposition (such as 2 + 3 = 5) even though the person is not consciously thinking of that proposition. Theologians distinguish belief "), _c('em', [_vm._v("that")]), _vm._v(" something is the case from belief "), _c('em', [_vm._v("in")]), _vm._v(" a person or ideal, as when a person believes in God or democracy. The latter seems closer to the biblical concept of "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0139"
    }
  }, [_vm._v("faith")]), _vm._v(". It seems clear, however, that belief in God is not possible without some propositional beliefs as well, since one could hardly believe in God if one did not believe that God existed or believe anything about God’s character.")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0038"
    }
  }, [_c('strong', [_vm._v("Berkeley, George (1685-1753).")]), _vm._v(" One of the great trio of British empiricist philosophers, along with John "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0232"
    }
  }, [_vm._v("Locke")]), _vm._v(" and David "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0182"
    }
  }, [_vm._v("Hume")]), _vm._v(". Berkeley, who was an Irish Anglican and became a bishop, is famous for his defense of "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0188"
    }
  }, [_vm._v("idealism")]), _vm._v(", holding that only minds and mental events and properties exist. By rejecting the existence of matter and affirming that “to be is to be perceived,” Berkeley hoped to undermine the basis for materialistic "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0025"
    }
  }, [_vm._v("atheism")]), _vm._v(". "), _c('em', [_vm._v("See also")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0122"
    }
  }, [_vm._v("empiricism")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0039"
    }
  }, [_c('strong', [_vm._v("Boethius (c. 480-525).")]), _vm._v(" An important link between the ancient and medieval worlds, Boethius’s translations and commentaries on "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0022"
    }
  }, [_vm._v("Aristotle")]), _vm._v(" were almost the sole source of medieval knowledge of that philosopher until the mid-twelfth century. Boethius himself attempted a synthesis of Aristotelian and Platonic views, and he developed a classical conception of God’s "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0129"
    }
  }, [_vm._v("eternity")]), _vm._v(" as the atemporal, all-at-once possession of an infinite life.")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0040"
    }
  }, [_c('strong', [_vm._v("Bonaventure, St. (c. 1217-1274).")]), _vm._v(" Franciscan medieval philosopher-theologian who, in contrast to Thomas "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0020"
    }
  }, [_vm._v("Aquinas")]), _vm._v(", argued that we can know by "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0336",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("reason")]), _vm._v(" and not merely from "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0348",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("revelation")]), _vm._v(" that the world had a beginning. Staunchly "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0028"
    }
  }, [_vm._v("Augustinian")]), _vm._v(" in approach, Bonaventure made important contributions to "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0310",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("philosophical theology")]), _vm._v(", to mystical theology and to Franciscan spirituality.")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0041"
    }
  }, [_c('strong', [_vm._v("Brunner, Emil (1889-1966).")]), _vm._v(" Highly influential Swiss theologian, who (along with Karl "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0033"
    }
  }, [_vm._v("Barth")]), _vm._v(") is credited with being the father of "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0271",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("neo-orthodoxy")]), _vm._v(", or dialectical theology. Brunner and Barth had a famous disagreement over the possibility of "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0264",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("natural theology")]), _vm._v(" and natural religious knowledge, with Barth arguing an unqualifiedly negative position and Brunner defending a more nuanced view that does not regard such undertakings as completely without value.")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0042"
    }
  }, [_c('strong', [_vm._v("Buber, Martin (1878-1965).")]), _vm._v(" Leading religious existentialist and prominent Jewish philosopher. Buber’s most famous work, "), _c('em', [_vm._v("I and Thou,")]), _vm._v(" makes an important distinction between the I-it relation people enjoy with objects and the kind of dialogical relationship between persons that is sometimes possible. Buber argues that such "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0184"
    }
  }, [_vm._v("I-thou relations")]), _vm._v(" provide an analogy with how God, who is the ultimate Thou, can be known.")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0043"
    }
  }, [_c('strong', [_vm._v("Buddhism.")]), _vm._v(" Religion founded by Siddhartha Gautama, the Buddha, or “enlightened one” (c. 563-483 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("B.C.")]), _vm._v("). Buddhism puts heavy emphasis on desire as the source of suffering and identifies the achievement of selflessness as the cure for this situation. Selflessness can be achieved through the Eightfold Path, freeing the individual from the wheel of "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0342",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("reincarnation")]), _vm._v(" and allowing him or her to achieve nirvana. Buddhism is divided into Theravada Buddhism and Mahayana Buddhism, the latter putting more emphasis on the role of the Buddha himself as a compassionate helper.")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0044"
    }
  }, [_c('strong', [_vm._v("Bultmann, Rudolf (1884-1976).")]), _vm._v(" German New Testament scholar and theologian who was strongly influenced by the early philosophy of Martin "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0169"
    }
  }, [_vm._v("Heidegger")]), _vm._v(". Bultmann pioneered the use of form criticism, which tries to uncover oral sayings and traditions that underlie the New Testament and understand the development of those traditions in light of the situation of the early church. Bultmann’s theology embodies an attempt to “demythologize” the conceptual framework of the New Testament by translating its message using concepts from "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0137"
    }
  }, [_vm._v("existentialism")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0045"
    }
  }, [_c('strong', [_vm._v("burden of proof.")]), _vm._v(" Legal term that indicates which party in a controversy has the responsibility of offering support for its position. Thus, in a U.S. criminal trial, the burden of proof rests with the prosecution; the defendant is presumed innocent unless the prosecution can establish guilt. In philosophy, the question of which party has the burden of proof is often disputed. Thus some nonbelievers assert “the presumption of atheism,” claiming that if we do not have a proof of God’s existence, then "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0025"
    }
  }, [_vm._v("atheism")]), _vm._v(" is the rational position. Philosophers in the "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0339",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Reformed Epistemology")]), _vm._v(" camp, on the other hand, argue that belief in God can be perfectly rational even without proof or any arguments at all, so long as there are no sound arguments against God’s existence. A middle position holds that neither side has any special burden of proof; the most reasonable view is simply the one that makes the most sense in light of all that is known.")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0046"
    }
  }, [_c('strong', [_vm._v("Butler, Joseph (1692-1752).")]), _vm._v(" Anglican bishop who made important contributions to both "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0397",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("theology")]), _vm._v(" and "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0311",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("philosophy")]), _vm._v(". Butler’s "), _c('em', [_vm._v("Analogy of Religion")]), _vm._v(" was well known in the eighteenth century for its defense of orthodox Christianity over against "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0093"
    }
  }, [_vm._v("deism")]), _vm._v(". Butler made many acute contributions to moral philosophy, including a celebrated critique of "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0167"
    }
  }, [_vm._v("hedonism")]), _vm._v(", in which he argued that pleasure is not generally the direct object of desire but rather is a byproduct of other things that humans desire.")]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "Letter_C"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/toc"
    }
  }, [_vm._v("C")])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse",
    attrs: {
      "id": "P0047"
    }
  }, [_c('strong', [_vm._v("Calvin, John (1509-1564).")]), _vm._v(" French Reformation theologian and founder of the tradition that today is most strongly represented in Presbyterian and Reformed churches. Calvin worked out his theological views while attempting to reform the Swiss city of Geneva. (In that tradition Calvinists since have often attempted redemptively to transform the various spheres of human society.) Calvin’s thought puts great emphasis on the "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0377",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("sovereignty")]), _vm._v(" of God and the ways in which "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0367",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("sin")]), _vm._v(" deforms the whole of human existence. Epistemologically, Calvinism puts emphasis on an innate sense of God’s reality that has been damaged by sin, on "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0348",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("revelation")]), _vm._v(" and on the inner testimony of the Holy Spirit. "), _c('em', [_vm._v("See also")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0340",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Reformed tradition")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0048"
    }
  }, [_c('strong', [_vm._v("Camus, Albert (1913-1960).")]), _vm._v(" French existentialist novelist and essayist. Camus is famous for his depiction of the absurd, which he described as the incongruity between the human self that demands meaning and purpose and an indifferent world that offers none. Camus described an existentialist hero who derives some meaning in this meaningless world by an attitude of revolt. This absurd hero clearly understands the futility of the revolt, but he takes up the burden (like Sisyphus, who rolls a rock up a mountain, even though that rock will inevitably roll down again). Thus he refuses “the leap” which Camus attributes to Søren "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0219"
    }
  }, [_vm._v("Kierkegaard")]), _vm._v(". Born in Algeria and active in the Resistance movement during World War II, Camus’s life was tragically cut short by an automobile accident. "), _c('em', [_vm._v("See also")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0137"
    }
  }, [_vm._v("existentialism")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0049"
    }
  }, [_c('strong', [_vm._v("Cappadocian fathers.")]), _vm._v(" A group of theologians most noted for their development of the orthodox doctrine of the "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0410",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Trinity")]), _vm._v(" and their battle with Arianism. Writing between the Council of Nicaea (325) and the Council of Constantinople (381), these church fathers included Basil of Caesarea, Gregory of Nyssa and Gregory of Nazianzus. Their understanding of the Trinity puts relatively more emphasis on the threeness of God than is characteristic of Latin theologians such as "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0028"
    }
  }, [_vm._v("Augustine")]), _vm._v(" and inspired a twentieth-century view known as "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0370",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("social trinitarianism")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0050"
    }
  }, [_c('strong', [_vm._v("Carnell, Edward John (1919-1967).")]), _vm._v(" One of the leading evangelical theologians and apologists in the twentieth century. Carnell was the first resident president of Fuller Theological Seminary and was a leader in helping the evangelical movement differentiate itself from "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0155"
    }
  }, [_vm._v("fundamentalism")]), _vm._v(", which he criticized as a form of “cultic Christianity.” Carnell’s apologetic arguments tended to link the case for Christianity with our knowledge of values and ourselves, and he was one of the first evangelicals to write about Søren "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0219"
    }
  }, [_vm._v("Kierkegaard")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0051"
    }
  }, [_c('strong', [_vm._v("categorical imperative.")]), _vm._v(" The supreme principle of "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0259",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("morality")]), _vm._v(", according to Immanuel "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0217"
    }
  }, [_vm._v("Kant")]), _vm._v(". Kant distinguished between a hypothetical imperative, which commands an "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0003"
    }
  }, [_vm._v("action")]), _vm._v(" conditionally as a means to an end that does not necessarily have to be willed (such as “Brush your teeth regularly if you want to avoid having cavities”), and a categorical imperative, which commands an action absolutely. Kant believed that there is only one categorical imperative: to act only on the basis of maxims that can be universally willed as a rational law. He thought that this one imperative could be formulated in several different ways, including the famous formula of the end in itself, in which we are enjoined to act in such a manner that we always recognize that rational agents have intrinsic worth and dignity and are not to be treated merely as a means to our own ends.")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0052"
    }
  }, [_c('strong', [_vm._v("categories.")]), _vm._v(" Constituents of a philosopher’s most basic classification scheme. The first philosopher to develop a set of categories was "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0022"
    }
  }, [_vm._v("Aristotle")]), _vm._v(", who famously included ten, namely substance, relation, quantity, quality, place, time, property, position, doing and being affected. Another famous categorial distinction is that which René "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0098"
    }
  }, [_vm._v("Descartes")]), _vm._v(" drew between two fundamental kinds of substance: mental substance and physical substance. Immanuel "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0217"
    }
  }, [_vm._v("Kant")]), _vm._v(" is famous for his argument that the basic categories of the understanding are provided by the mind and thus that it is impossible for us to know the world as it is in itself; we know it only as it is structured by our own fundamental concepts. His view has inspired a variety of views known collectively as "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0017"
    }
  }, [_vm._v("antirealism")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0053"
    }
  }, [_c('strong', [_vm._v("category mistake.")]), _vm._v(" Misunderstanding by regarding a term that belongs to one logical category as if it belonged to a different logical category. Philosopher Gilbert Ryle, who popularized this concept, gave as an example someone who is shown an auditor’s report on the financial accounts of a college. This reader of the report confusedly thinks that what is described in the report must be the real college, since the report covers all aspects of the college, and that experiences of the college’s buildings, classrooms, libraries and so on must somehow be illusory. Mistakes of this sort are thought by Ryle and others to be grounded in the misunderstanding of language and are regarded as the ground of many philosophical puzzles.")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0054"
    }
  }, [_c('strong', [_vm._v("causation.")]), _vm._v(" The fundamental kind of relation expressed by such terms as "), _c('em', [_vm._v("produce, originate")]), _vm._v(" and "), _c('em', [_vm._v("bring about.")]), _vm._v(" The items related (causes and effects) may be persons, objects, states of affairs or events. "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0022"
    }
  }, [_vm._v("Aristotle")]), _vm._v(" recognized four types of causality: efficient, final, formal and material. David "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0182"
    }
  }, [_vm._v("Hume")]), _vm._v(" famously tried to analyze causality as a constant conjunction between different types of events. Philosophers such as Thomas "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0341",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Reid")]), _vm._v(" have argued for a fundamental type of causation known as “agent causality,” in which persons (not merely events occurring in persons) bring about effects. Important philosophical disputes in this area include debates about "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0101"
    }
  }, [_vm._v("determinism")]), _vm._v(" (Are all events causally determined, or do persons sometimes possess "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0151"
    }
  }, [_vm._v("free will")]), _vm._v("?) and about the "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0111"
    }
  }, [_vm._v("principle")]), _vm._v(" of sufficient reason, which in some forms holds that all events (at least of a certain type) or all contingent substances must have a cause. This principle plays a key role in "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0079"
    }
  }, [_vm._v("cosmological")]), _vm._v(", or first cause, arguments for God’s existence.")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0055"
    }
  }, [_c('strong', [_vm._v("chain of being.")]), _vm._v(" A key element in the worldview of many ancient, medieval and early modern philosophers, who assumed a principle of plenitude in which beings of every possible type must be actualized, from the lowest to the highest. Thus in the medieval world it was common to think of various entities as possessing different degrees of being, from insignificant bare specks of matter through plants and animals and humans and on to angelic beings and God himself, who possesses the highest possible degree of being. The universe is a vast hierarchy of beings, and it is good that all positions in the hierarchy are filled. "), _c('em', [_vm._v("See also")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0272",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Neo-Platonism")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0056"
    }
  }, [_c('strong', [_vm._v("character.")]), _vm._v(" The comprehensive set of traits that make up the intellectual and ethical substance of a person. A character is primarily a set of dispositions to behave in certain ways in characteristic circumstances. To evaluate a person’s character is to focus on the abiding "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0417",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("virtues")]), _vm._v(", or excellences, in a person over time instead of simply looking at individual "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0003"
    }
  }, [_vm._v("actions")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0057"
    }
  }, [_c('strong', [_vm._v("Chesterton, G. K. (1874-1936).")]), _vm._v(" A prolific, imaginative writer in many fields, today best known as a Christian apologist and for his Father Brown detective stories. Some of Chesterton’s most-read works include "), _c('em', [_vm._v("Orthodoxy, Heretics, The Everlasting Man")]), _vm._v(" and "), _c('em', [_vm._v("The Man Who Was Thursday.")]), _vm._v(" He was a major influence on C. S. "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0226"
    }
  }, [_vm._v("Lewis")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0058"
    }
  }, [_c('strong', [_vm._v("Christology.")]), _vm._v(" The branch of Christian "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0397",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("theology")]), _vm._v(" that attempts to clarify the identity and nature of Jesus of Nazareth, understood as “the Christ” (from the Greek equivalent to the Hebrew term Messiah, which means “anointed one”). Within orthodox Christianity, Christology is concerned with understanding how Jesus can be both divine and human, and with the significance of his life, death and resurrection. "), _c('em', [_vm._v("See also")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0195"
    }
  }, [_vm._v("incarnation")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0059"
    }
  }, [_c('strong', [_c('em', [_vm._v("City of God.")])]), _vm._v(" Classic work (written between 413 and 426) by "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0028"
    }
  }, [_vm._v("Augustine")]), _vm._v(" of Hippo, in which human history is interpreted as a struggle between an earthly kingdom founded on self-love and a divinely established society founded on God’s "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0164"
    }
  }, [_vm._v("grace")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0060"
    }
  }, [_c('strong', [_vm._v("Clarke, Samuel (1675-1729).")]), _vm._v(" English philosopher, theologian and preacher who is closely linked to Isaac Newton’s scientific thought. Clarke championed orthodoxy from the viewpoint of "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0334",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("rationalism")]), _vm._v(" over against "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0093"
    }
  }, [_vm._v("deism")]), _vm._v(" and developed an original and powerful version of the "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0079"
    }
  }, [_vm._v("cosmological argument")]), _vm._v(". He also defended Newton’s views of space and time against those of Gottfried "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0223"
    }
  }, [_vm._v("Leibniz")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0061"
    }
  }, [_c('strong', [_vm._v("Clement of Alexandria (c. 150-220).")]), _vm._v(" One of the church fathers who, in contrast to "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0392",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tertullian")]), _vm._v(", took a positive attitude toward "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0311",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("philosophy")]), _vm._v(" and Greek learning. Clement held that the Greek writers were able to discern important truths because the divine wisdom, or "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0234"
    }
  }, [_vm._v("Logos")]), _vm._v(", is present in all humans. Though philosophy is inferior to and cannot substitute for "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0348",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("revelation")]), _vm._v(", Clement thought its study can deepen one’s understanding of revelation.")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0062"
    }
  }, [_c('strong', [_vm._v("cognition, cognitive.")]), _vm._v(" The process by which knowledge is gained, and that which pertains to that process. What is cognitive is knowable, and thus a cognitive proposition is one that can be true or false. "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0233"
    }
  }, [_vm._v("Logical positivism")]), _vm._v(" is distinguished by the claim that the only genuine cognitive propositions (other than analytic ones that are made true by linguistic meaning) are those that can be verified by sense experiences. Positivists claim that theological propositions fail this test and thus lack cognitive meaning, though they might have poetic or emotive meaning. "), _c('em', [_vm._v("See also")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0277",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("noncognitivism")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0063"
    }
  }, [_c('strong', [_vm._v("coherentism.")]), _vm._v(" An epistemological theory holding that the justification for "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0037"
    }
  }, [_vm._v("beliefs")]), _vm._v(" consists in the relations among the beliefs. A coherentist thus typically denies that there are any special propositions that are basic or foundational. Rather, the structure of beliefs is like a web in which some beliefs are more central than others but in which some beliefs give mutual support to others as part of a network. More radical forms of coherentism not only adopt a coherentist account of justification but also a coherentist account of "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0411",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("truth")]), _vm._v(", in which true propositions are those that would be part of an ideally coherent system of beliefs. "), _c('em', [_vm._v("See also")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0124"
    }
  }, [_vm._v("epistemology")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0064"
    }
  }, [_c('strong', [_vm._v("colonialism, paternalism, imperialism.")]), _vm._v(" Critical terms used by multiculturalists for academic work that they see as permeated by attitudes of Western superiority. The criticized views are often associated with male domination as well.")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0065"
    }
  }, [_c('strong', [_vm._v("common grace.")]), _vm._v(" The "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0164"
    }
  }, [_vm._v("grace")]), _vm._v(" of God that is extended not only to the elect whom God saves but to all human creatures and even to the natural order as a whole. Theologians who emphasize common grace say that it is God’s gracious action (“sending rain upon the just and the unjust”) that makes it possible for sinful humans to acquire knowledge and develop such positive cultural achievements as government and the arts.")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0066"
    }
  }, [_c('strong', [_vm._v("Common Sense philosophy.")]), _vm._v(" Often referred to as “Scottish Common Sense philosophy” or “Scottish realism,” this type of philosophy was originated by Thomas "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0341",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Reid")]), _vm._v(" and was popular both in Great Britain and in North America throughout the nineteenth century. Reid argued against what he took to be the skepticism of David "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0182"
    }
  }, [_vm._v("Hume")]), _vm._v(" by trying to show that the principles underlying "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0368",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("skepticism")]), _vm._v(" were more dubious than the principles of common sense. While not indubitable, said Reid, the principles of common sense are universally knowable and in practice impossible to reject. Common Sense philosophers like Reid usually defended basic principles of morality and religion as well as the reliability of memory and sense perception and the basic credibility of testimony. "), _c('em', [_vm._v("See also")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0335",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("realism")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0067"
    }
  }, [_c('strong', [_vm._v("communitarianism.")]), _vm._v(" Form of political philosophy, traceable to G. W. F. "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0168"
    }
  }, [_vm._v("Hegel")]), _vm._v(". Communitarianism rejects the liberal view that takes individual rights to be the foundation of society, putting in its place a view that sees individuals as constituted by the groups of which they are a part. Communitarians are therefore concerned to foster strong communities and social institutions, believing that these social institutions can have rights and obligations in themselves and also that they can create rights and obligations for individuals.")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0068"
    }
  }, [_c('strong', [_vm._v("compatibilism.")]), _vm._v(" In philosophy of action, the view that causal "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0101"
    }
  }, [_vm._v("determinism")]), _vm._v(" is logically compatible with "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0151"
    }
  }, [_vm._v("free will")]), _vm._v(". The compatibilist who accepts both determinism and free will is called a soft determinist. Compatibilism usually defines free will as an "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0003"
    }
  }, [_vm._v("action")]), _vm._v(" that is caused by the individual’s own desires or wishes, rather than being coerced by some external power. The alternative possibilities that seem necessary for genuine free will are interpreted by compatibilists as hypothetical in character. For example, the individual who freely gave money to a charity could have refrained from giving the money "), _c('em', [_vm._v("if")]), _vm._v(" the individual had wished to do so or "), _c('em', [_vm._v("if")]), _vm._v(" the situation had been different. Critics of compatibilism argue that genuine freedom requires an individual to have more than one possibility that is actually possible at the time of choosing, not merely possibilities that would be open if certain facts that do not obtain were to obtain.")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0069"
    }
  }, [_c('strong', [_vm._v("complementarity.")]), _vm._v(" Physicist Niels Bohr’s term for his view that that there are alternative, seemingly incompatible descriptions of the world that are nonetheless true or at least necessarily must be accepted. The principle of complementarity is linked to quantum mechanics and the uncertainty principle, which makes it impossible to specify both a specific location and a specific motion for subatomic particles. The classical example of complementarity is the way light must be understood as consisting of both waves and particles. Some theologians and philosophers of science have sought to extend the principle of complementarity metaphorically so as to understand how theological and scientific descriptions of the world could both be true.")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0070"
    }
  }, [_c('strong', [_vm._v("conceptualism.")]), _vm._v(" Compromise position between "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0335",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("realism")]), _vm._v(" and "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0276",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("nominalism")]), _vm._v(" on the question of the status of universals such as “goodness.” The realist claims that these universals exist objectively, independently of the mind. The nominalist holds that universals are merely names that refer to a group of particulars. The conceptualist holds that real concepts are associated with universal terms but that these concepts do not exist independently of the mind.")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0071"
    }
  }, [_c('strong', [_vm._v("Confucianism.")]), _vm._v(" Chinese school of ethical, political and religious teachings commonly attributed to Confucius (c. 551-479 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("B.C.")]), _vm._v("). Confucianism places great weight on the cultivation of ethical virtues such as kingliness, humaneness and gentlemanliness that are cultivated through rituals. Ethical duties within Confucianism depend on one’s social and family position. There is some dispute over the religious character of Confucianism, centering on the nature of "), _c('em', [_vm._v("tian,")]), _vm._v(" or “heaven,” which is in some way the ground of our ethical duties. Some have interpreted this concept in a transcendent, metaphysical way, while neo-Confucians tend to think of “heaven” as a metaphorical way of describing the natural ethical order of things.")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0072"
    }
  }, [_c('strong', [_vm._v("conscience.")]), _vm._v(" The faculty that approves or disapproves of conduct from a moral point of view. Joseph "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0046"
    }
  }, [_vm._v("Butler")]), _vm._v(" made conscience (understood as a divinely implanted faculty) the centerpiece of his moral theory, arguing that, although following conscience does in fact lead to the best consequences for everyone in the long run, the authority of conscience is preeminent and not based on results. In the medieval period many thinkers viewed conscience as the natural human ability to grasp the moral order, but Thomas "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0020"
    }
  }, [_vm._v("Aquinas")]), _vm._v(" described that ability as “synderesis” and distinguished it from conscience, which is an ability to apply moral principles to particular situations. "), _c('em', [_vm._v("See also")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0259",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("morality")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0073"
    }
  }, [_c('strong', [_vm._v("consciousness.")]), _vm._v(" Psychological states such as pain, sensations, thoughts and other objects of mental awareness are called conscious states. There appears to be something deeply private and mysterious about consciousness, leading some philosophers to doubt whether it is possible to truly know the content of others’ consciousness (the problem of other minds). Consciousness is a key dimension of the "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0251",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("mind-body problem")]), _vm._v(". Many dualists cite consciousness as the defining property of mental or spiritual reality, and materialists have great difficulty explaining it, leading some (such as advocates of logical "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0036"
    }
  }, [_vm._v("behaviorism")]), _vm._v(" and "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0120"
    }
  }, [_vm._v("eliminative materialism")]), _vm._v(") to the extreme position of denying the existence of consciousness altogether. ("), _c('em', [_vm._v("see")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0113"
    }
  }, [_vm._v("dualism")]), _vm._v("; "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0245",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("materialism")]), _vm._v(".) Contemporary neurological research attempts to understand the physical basis of consciousness. Attempts by cognitive scientists to design a conscious computer implicitly assume philosophical stances toward consciousness.")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0074"
    }
  }, [_c('strong', [_vm._v("consequentialism.")]), _vm._v(" An ethical theory that sees the ethical goodness or wrongness of an act as determined by the nonmoral consequences of the act, such as the amount of pleasure or pain the act produces. A good example is "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0414",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("utilitarianism")]), _vm._v(", which claims that the morally right act is the one that produces the best consequences for all who will be affected. Consequentialist theories are contrasted with "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0096"
    }
  }, [_vm._v("deontological")]), _vm._v(" theories, which hold that rightness and wrongness are not completely determined by consequences.")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0075"
    }
  }, [_c('strong', [_vm._v("conservation of creation.")]), _vm._v(" Although popular views of "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0082"
    }
  }, [_vm._v("creation")]), _vm._v(" understand God’s activity to be concerned with the origination of the universe, traditional theological accounts have held that the continued existence of the universe is also essentially linked to God’s creative activity. On this view, God’s activity in conserving the universe is really the same as his activity in beginning it. "), _c('em', [_vm._v("See also")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0330",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("providence")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0076"
    }
  }, [_c('strong', [_vm._v("contingency.")]), _vm._v(" A characteristic of finite things that exist but do not exist necessarily. Those who support the "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0079"
    }
  }, [_vm._v("cosmological argument")]), _vm._v(" believe that the contingency of the natural order shows that it must have its ground of existence outside itself and that the ultimate ground for the existence of contingent things must be a being whose existence is not contingent but necessary—a being identifiable as God. "), _c('em', [_vm._v("See also")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0267",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("necessary being")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0077"
    }
  }, [_c('strong', [_vm._v("conversion.")]), _vm._v(" Within Christianity, the change in an individual that represents the beginning of new life in Christ. For many who come to "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0139"
    }
  }, [_vm._v("faith")]), _vm._v(" as adults, conversion represents a specific experience. The nature of this conversion experience and its evidential status is debated by psychologists and philosophers of religion. It is noteworthy that conversions to other religions and even secular “faiths” such as Marxism are possible as well. "), _c('em', [_vm._v("See also")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0354",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("salvation")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0078"
    }
  }, [_c('strong', [_vm._v("correspondence theory of truth.")]), _vm._v(" Most natural and widely held view of propositional "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0411",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("truth")]), _vm._v(", which holds that a proposition is true if it corresponds to or agrees with reality. The core of the correspondence theory of truth is the commonsense notion that the truth or falsity of a proposition is determined by an independent reality. Thus this view of truth is linked to metaphysical "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0335",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("realism")]), _vm._v(". When developed beyond this commonsense notion of truth (for example, by the metaphysical postulation of a realm of facts corresponding to propositions), the correspondence theory becomes controversial. Its major rivals are the coherentist and pragmatic theories of truth, which tie truth closely to human thinking and human acting, respectively. "), _c('em', [_vm._v("See also")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0063"
    }
  }, [_vm._v("coherentism")]), _vm._v("; "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0323",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("pragmatism")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0079"
    }
  }, [_c('strong', [_vm._v("cosmological arguments.")]), _vm._v(" A family of arguments for the existence of God that postulate God’s existence as the ultimate cause or ground or explanation of the cosmos. Cosmological arguments normally make use of some principle of explanation, causality or "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0385",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("sufficient reason")]), _vm._v(". Thomas "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0020"
    }
  }, [_vm._v("Aquinas")]), _vm._v(" and Samuel "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0060"
    }
  }, [_vm._v("Clarke")]), _vm._v(" are among the more famous proponents of this type of argument. "), _c('em', [_vm._v("See also")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0394",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("theistic arguments")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0080"
    }
  }, [_c('strong', [_vm._v("counterfactuals.")]), _vm._v(" A conditional proposition (usually expressed in the form “if "), _c('em', [_vm._v("p,")]), _vm._v(" then "), _c('em', [_vm._v("q”")]), _vm._v(") in which the antecedent "), _c('em', [_vm._v("(p)")]), _vm._v(" is false. Examples include such propositions as “If the moon were made of green cheese, then it would be tasty” and “If Abraham Lincoln had not been assassinated, then racial reconciliation after the Civil War would have been advanced.” There is a vigorous debate over the status of counterfactuals that deal with free human actions, such as “If John had been offered a $5,000 bribe, he would have freely refused it.” Advocates of Molinism claim that such propositions have a truth value that God does not determine. ("), _c('em', [_vm._v("See")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0250",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("middle knowledge")]), _vm._v(".) They claim as well that God knows all such propositions and uses this knowledge in the providential governance of the universe. This allows God to control the outcome of events without impinging on human freedom. "), _c('em', [_vm._v("See also")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0101"
    }
  }, [_vm._v("determinism")]), _vm._v("; "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0151"
    }
  }, [_vm._v("free will")]), _vm._v("; "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0330",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("providence")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0081"
    }
  }, [_c('strong', [_vm._v("covenant.")]), _vm._v(" A mutually binding relationship between two or more parties. A covenantal relationship goes beyond a mere contractual relationship by its formation of genuine bonds between the parties. In theology, "), _c('em', [_vm._v("covenant")]), _vm._v(" refers to God’s gracious acts in establishing real relations with his human creatures. Theologians in the "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0340",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Reformed tradition")]), _vm._v(" have given special emphasis to the notions of covenant and covenant people in attempting to understand the biblical narrative.")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0082"
    }
  }, [_c('strong', [_vm._v("creation.")]), _vm._v(" God’s activity in originating and maintaining the universe and any other creatures that may exist, such as "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0013"
    }
  }, [_vm._v("angels")]), _vm._v(" and "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0094"
    }
  }, [_vm._v("demons")]), _vm._v(". Christian theology holds that God created the world freely out of nothing "), _c('em', [_vm._v("(ex nihilo)")]), _vm._v(" and that, although God is immanently present in creation, he transcends that creation.")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0083"
    }
  }, [_c('strong', [_vm._v("creation order.")]), _vm._v(" Lawlike structure or order that is rooted in God’s intentions at "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0082"
    }
  }, [_vm._v("creation")]), _vm._v(". Those who affirm this notion typically think that there are particular “orders” or “spheres” of creation, such as the state and the family, each with its own purposes and norms. The term is also used to refer to a particular order or sphere.")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0084"
    }
  }, [_c('strong', [_vm._v("creationism.")]), _vm._v(" (1) The theory that God’s creation occurred directly and not through some Darwinian mechanism of evolution. Many creationists teach that the universe is relatively young (ten to fifty thousand years old), though some advocates of "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0204"
    }
  }, [_vm._v("intelligent design")]), _vm._v(" are willing to entertain the idea of an older universe. (2) The theory that the "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0376",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("soul")]), _vm._v(" of each human being is created directly by God and infused into the person, rather than being a biological product of the father and mother.")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0085"
    }
  }, [_c('strong', [_vm._v("cultural relativism.")]), _vm._v(" "), _c('em', [_vm._v("See")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0343",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("relativism")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0086"
    }
  }, [_c('strong', [_vm._v("cumulative case arguments.")]), _vm._v(" Arguments for the existence of God (or some other complex claim) that do not consist of a single decisive argument but rather try to show that God’s existence makes more sense than any alternative hypothesis in light of all the available evidence. Richard "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0387",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Swinburne")]), _vm._v(", for example, presented a large number of arguments, none of which has decisive force. But since each argument has some evidential force, the cumulative case is alleged to make the existence of God probable. "), _c('em', [_vm._v("See also")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0394",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("theistic arguments")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0087"
    }
  }, [_c('strong', [_vm._v("Cupitt, Don (1934- ).")]), _vm._v(" Radical English theologian who has explicitly embraced "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0025"
    }
  }, [_vm._v("atheism")]), _vm._v(" in books such as "), _c('em', [_vm._v("Taking Leave of God.")]), _vm._v(" Cupitt became well known for producing a BBC documentary series, "), _c('em', [_vm._v("The Sea of Faith,")]), _vm._v(" which spawned a network of the same name devoted to theological "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0017"
    }
  }, [_vm._v("antirealism")]), _vm._v(", which views religions as human constructions.")]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "Letter_D"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/toc"
    }
  }, [_vm._v("D")])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse",
    attrs: {
      "id": "P0088"
    }
  }, [_c('strong', [_vm._v("Daly, Mary (1928-2010).")]), _vm._v(" Feminist theologian who began as a Roman Catholic but moved to a “post-Christian” radical feminist position in "), _c('em', [_vm._v("Beyond God the Father.")]), _vm._v(" Daly argues that traditional "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0393",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("theism")]), _vm._v(" is a patriarchal, hierarchical view rooted in male-dominated cultures. "), _c('em', [_vm._v("See also")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0142"
    }
  }, [_vm._v("feminism")]), _vm._v("; "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0158"
    }
  }, [_vm._v("gender")]), _vm._v("; "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0302",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("patriarchy, matriarchy")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0089"
    }
  }, [_c('strong', [_vm._v("Daoism.")]), _vm._v(" "), _c('em', [_vm._v("See")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0390",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Taoism")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0090"
    }
  }, [_c('strong', [_vm._v("Darwinism.")]), _vm._v(" The theory of the development of biological life originated by Charles Darwin (1809-1882), which holds that the mechanism for evolutionary development is made up of chance variations and natural selection involving competition for survival and reproduction. Darwinism sharply reduced the popularity of the argument from "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0099"
    }
  }, [_vm._v("design")]), _vm._v(" in England and North America. Many religious thinkers regard Darwinism as compatible with the view that God is the Creator of the universe, seeing natural selection as a means employed by God. Nevertheless, atheists often regard Darwinism as strongly supporting their "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0427",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("worldview")]), _vm._v(". That opinion is shared by many advocates of “creation science,” who advocate non-Darwinian accounts of the origin of species. Darwinian thought is influential today in such fields as psychology and sociology. Advocates of Darwinian approaches view many aspects of human culture, even such things as "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0130"
    }
  }, [_vm._v("ethics")]), _vm._v(" and religion, with respect to presumed reproductive advantages they provide. "), _c('em', [_vm._v("See also")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0084"
    }
  }, [_vm._v("creationism")]), _vm._v("; "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0135"
    }
  }, [_vm._v("evolution, theory of")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0091"
    }
  }, [_c('strong', [_vm._v("death, survival of.")]), _vm._v(" Continued existence past the end of a person’s biological life. All of the great religions in some way give an answer to the question of what happens after death and the implications of this answer for the meaning of life and death. Some of the alternative ways humans have been thought to survive death include "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0342",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("reincarnation")]), _vm._v(", disembodied existence of the "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0376",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("soul")]), _vm._v(" and bodily "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0346",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("resurrection")]), _vm._v(", with the latter two being regarded as successive states by many Christians. Options to personal survival include absorption into some absolute mind and being remembered by God. Some contemporary antirealist theologians think of survival after death not as a possible factual state of affairs but as a picture or myth that is intended to give meaning to life here and now. Philosophical questions raised by the possibility of survival of death center on questions of personal "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0189"
    }
  }, [_vm._v("identity")]), _vm._v(" and the relation of the person to the body.")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0092"
    }
  }, [_c('strong', [_vm._v("deductive argument.")]), _vm._v(" A chain of reasoning in which a series of propositions (the premises), if true, are supposed necessarily to imply the truth of another proposition (the conclusion) by virtue of certain logical principles or rules of inference. A deductive argument is logically "), _c('em', [_vm._v("valid")]), _vm._v(" when the truth of the premises does in fact necessarily imply the truth of the conclusion, whether or not all of the premises are true. If an argument is logically valid, then all other arguments that have the same logical form will also be valid. A deductive argument is logically "), _c('em', [_vm._v("sound")]), _vm._v(" when all of the premises are true and it is logically valid. Classical examples of deductive reasoning are given by the syllogisms of traditional logic, which include such arguments as the following: (1) “All humans are mortal; Socrates is a human; therefore Socrates is mortal.” (This example conforms to the argument form “All A is B; p is A; therefore p is B.”) (2) “Either George W. Bush is a Democrat or God exists; George W. Bush is not a Democrat; therefore God exists.” (This example conforms to the argument form “Either p or q; not p; therefore q.”) "), _c('em', [_vm._v("See also")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0197"
    }
  }, [_vm._v("inductive reasoning")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0093"
    }
  }, [_c('strong', [_vm._v("deism.")]), _vm._v(" The belief that God created the world but is not sustaining it providentially. In other words, though God exists, he has no interaction with the created world. This term is also used to support the view that true religion is a natural religion grounded in "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0336",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("reason")]), _vm._v(" rather than any authoritative "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0378",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("special revelation")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0094"
    }
  }, [_c('strong', [_vm._v("demons.")]), _vm._v(" Traditionally viewed as created spiritual beings who have rebelled against God as allies of Satan, their leader. Many liberal theologians regard talk of demons as a symbolic way of speaking about the power of evil. The New Testament records many cases of Jesus or his followers casting out demons from people. Most biblical scholars today accept this material as historical, but those who reject the metaphysical existence of demons explain these possessions as forms of mental illness and regard the stories of exorcism as cases of psychosomatic healing. "), _c('em', [_vm._v("See also")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0013"
    }
  }, [_vm._v("angels")]), _vm._v("; "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0133"
    }
  }, [_vm._v("evil, nature of")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0095"
    }
  }, [_c('strong', [_vm._v("demythologization.")]), _vm._v(" "), _c('em', [_vm._v("see")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0044"
    }
  }, [_vm._v("Bultmann, Rudolf")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0096"
    }
  }, [_c('strong', [_vm._v("deontological theory.")]), _vm._v(" Ethical theory holding that the rightness or wrongness of "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0003"
    }
  }, [_vm._v("actions")]), _vm._v(" is not completely determined by consequences (from Greek "), _c('em', [_vm._v("deon, deont-,")]), _vm._v(" meaning “obligation,” “necessity”). Thus, a deontologist holds that some actions are wrong in themselves (or at least that they are wrong prima facie), not wrong merely because of the results of the action. Immanuel "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0217"
    }
  }, [_vm._v("Kant")]), _vm._v(" is the most famous defender of a deontological ethical theory. Traditional Christian "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0130"
    }
  }, [_vm._v("ethics")]), _vm._v(" has also had a deontological strand in holding that some types of actions are absolutely wrong, or wrong in all circumstances.")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0097"
    }
  }, [_c('strong', [_vm._v("Derrida, Jacques (1930-2004).")]), _vm._v(" French philosopher who is regarded as the founder of deconstructionism, an important stream in what is often called "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0322",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("postmodernism")]), _vm._v(" or poststructuralism. Derrida criticizes modernity for its commitment to “the metaphysics of presence” and what Martin "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0169"
    }
  }, [_vm._v("Heidegger")]), _vm._v(" termed “onto-theology.” Deconstruction itself fosters a way of thinking that looks for contradictions between the ideals of "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0254",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("modernism")]), _vm._v(" and its realities. It also promotes a way of reading that looks for contradictions between what a writer intends to say and what the text actually says. "), _c('em', [_vm._v("See also")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0382",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("structuralism")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0098"
    }
  }, [_c('strong', [_vm._v("Descartes, René (1596-1650).")]), _vm._v(" French philosopher and mathematician, generally regarded as the father of modern philosophy. Descartes was a rationalist who is well known for his attempt to gain certainty through a process of universal, methodical "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0112"
    }
  }, [_vm._v("doubt")]), _vm._v(" in which he posed the possibility that his waking experience was indistinguishable from a dream world as well as the possibility that he was being deceived by an all-powerful evil genius. After establishing clear and distinct ideas as his standard for "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0411",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("truth")]), _vm._v(", Descartes defended soul-body (or mind-body) "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0113"
    }
  }, [_vm._v("dualism")]), _vm._v(" and gave a number of proofs for the existence of God. "), _c('em', [_vm._v("See also")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0263",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("natural light")]), _vm._v("; "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0334",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("rationalism")]), _vm._v("; "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0368",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("skepticism")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0099"
    }
  }, [_c('strong', [_vm._v("design argument.")]), _vm._v(" "), _c('em', [_vm._v("see")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0391",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("teleological argument")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0100"
    }
  }, [_c('strong', [_vm._v("design theory.")]), _vm._v(" "), _c('em', [_vm._v("see")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0204"
    }
  }, [_vm._v("intelligent design")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0101"
    }
  }, [_c('strong', [_vm._v("determinism.")]), _vm._v(" The view that all natural events, including human choices and "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0003"
    }
  }, [_vm._v("actions")]), _vm._v(", are the product of past states of affairs in accordance with causal necessity. Thus the determinist holds that, given the state of the universe at any particular time, plus the causal laws that govern events in the natural world, the state of the universe at every future time is fixed. Various kinds of determinism are possible depending on the nature of the causally determining forces. Most determinists today are scientific determinists who believe the laws of nature are the determining factors, but theological determinism, in which God directly determines every event, is also possible. "), _c('em', [_vm._v("See also")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0054"
    }
  }, [_vm._v("causation")]), _vm._v("; "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0068"
    }
  }, [_vm._v("compatibilism")]), _vm._v("; "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0151"
    }
  }, [_vm._v("free will")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0102"
    }
  }, [_c('strong', [_vm._v("Dewey, John (1859-1952).")]), _vm._v(" One of the leaders of American "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0323",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("pragmatism")]), _vm._v(" and an advocate of democratic liberalism and educational reform. Dewey was committed to philosophical "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0265",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("naturalism")]), _vm._v(" and, unlike his fellow pragmatist William "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0209"
    }
  }, [_vm._v("James")]), _vm._v(", had little interest in "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0344",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("religious experience")]), _vm._v(" or the possibility of an "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0005"
    }
  }, [_vm._v("afterlife")]), _vm._v(". In "), _c('em', [_vm._v("A Common Faith")]), _vm._v(" he attempted to develop a version of religious "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0139"
    }
  }, [_vm._v("faith")]), _vm._v(" (or perhaps a successor to such faith) that involved the veneration of the natural order, human potential and the ideals of democracy.")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0103"
    }
  }, [_c('strong', [_vm._v("dialectic.")]), _vm._v(" A process of thinking or argument that involves contradictions and their resolution, sometimes in the form of questions and opposing answers. The term has been used very differently by different philosophers. "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0315",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Plato")]), _vm._v(" thought of dialectic as the highest form of reasoning. "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0022"
    }
  }, [_vm._v("Aristotle")]), _vm._v(" and later medieval philosophers tended to think of dialectic as a formal method of disputation. Immanuel "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0217"
    }
  }, [_vm._v("Kant")]), _vm._v(" developed a “transcendental dialectic” that attempted to reveal the contradictions into which uncritical reason falls. G. W. F. "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0168"
    }
  }, [_vm._v("Hegel")]), _vm._v(" developed a dialectical logic, which he saw as providing the formal structure of history as well, seen as the progressive unfolding of the Absolute. This historical dialectic was taken over by Karl "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0243",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Marx")]), _vm._v(" and put to use in his dialectical materialism.")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0104"
    }
  }, [_c('strong', [_vm._v("dialectical materialism.")]), _vm._v(" "), _c('em', [_vm._v("see")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0244",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Marxism")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0105"
    }
  }, [_c('strong', [_vm._v("dialectical theology.")]), _vm._v(" "), _c('em', [_vm._v("see")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0271",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("neo-orthodoxy")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0106"
    }
  }, [_c('strong', [_vm._v("divine action.")]), _vm._v(" Events brought about by God understood as an intentional agent. It is characteristic both of the biblical narrative and of classical theism to see God as a being who acts. Traditional theologians have distinguished between God’s actions in creating and conserving the world and its general providential ordering and God’s actions in special or particular "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0330",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("providence")]), _vm._v(" and "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0252",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("miracles")]), _vm._v(" at particular points in history. Some contemporary theologians do not think of God as an intentional agent and so regard all talk of divine action as metaphorical. Others are willing to accept God’s activity in "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0082"
    }
  }, [_vm._v("creation")]), _vm._v(" but regard “special acts” as events that are brought about through the normal natural order yet have a special revelatory function. Philosophical debates continue about the implications of divine action for God’s relation to time and space. "), _c('em', [_vm._v("See also")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0003"
    }
  }, [_vm._v("actions")]), _vm._v(" (divine and human).")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0107"
    }
  }, [_c('strong', [_vm._v("divine attributes.")]), _vm._v(" "), _c('em', [_vm._v("See")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0027"
    }
  }, [_vm._v("attributes of God")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0108"
    }
  }, [_c('strong', [_vm._v("divine command theories.")]), _vm._v(" Ethical theories holding that at least one of the reasons that "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0003"
    }
  }, [_vm._v("actions")]), _vm._v(" are right or wrong is that they are commanded or forbidden by God. Philosophers have tended to reject divine command theories, either by alleging that they make ethical duties arbitrary or by claiming that they are incompatible with moral "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0030"
    }
  }, [_vm._v("autonomy")]), _vm._v(". ("), _c('em', [_vm._v("See")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0131"
    }
  }, [_vm._v("Euthyphro dilemma")]), _vm._v(".) However, such philosophers as Robert Adams and Philip Quinn have mounted convincing defenses of divine command theories against these criticisms. "), _c('em', [_vm._v("See also")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0130"
    }
  }, [_vm._v("ethics")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0109"
    }
  }, [_c('strong', [_vm._v("dogma.")]), _vm._v(" A doctrine or teaching of the church. Roman Catholic and Orthodox theologians regard dogmas as those central doctrines formally accepted by the church and not simply asserted by theologians.")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0110"
    }
  }, [_c('strong', [_vm._v("Dooyeweerd, Herman (1894-1977).")]), _vm._v(" Dutch philosopher and legal scholar whose philosophical thinking was inspired by the Dutch Reformed theologian Abraham Kuyper. Dooyeweerd’s philosophy, developed in cooperation with his colleague Dirk Vollenhoven, is often called “the philosophy of the law-idea.” Dooyeweerd viewed philosophies as perspectival—that is, as shaped by fundamental religious attitudes of the heart—and tried to construct a philosophy that is distinctively Christian in that it recognizes the "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0377",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("sovereignty")]), _vm._v(" of God in the various spheres of the "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0083"
    }
  }, [_vm._v("creation order")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0111"
    }
  }, [_c('strong', [_vm._v("double effect, principle of.")]), _vm._v(" The view that there is a significant moral difference between consequences of an "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0003"
    }
  }, [_vm._v("action")]), _vm._v(" that are intended and those that may only be foreseen but not intended. According to this view, for example, it might be morally permissible to administer a pain-relieving drug to a dying person with the intent of alleviating suffering even if it is foreseen that the drug might shorten the life of the dying person. "), _c('em', [_vm._v("See also")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0130"
    }
  }, [_vm._v("ethics")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0112"
    }
  }, [_c('strong', [_vm._v("doubt.")]), _vm._v(" An attitude of uncertainty, directed toward a proposition or person. As the etymological connection with "), _c('em', [_vm._v("double")]), _vm._v(" makes clear, to be in doubt is to be of two minds, unsure of what to believe. René "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0098"
    }
  }, [_vm._v("Descartes")]), _vm._v(" proposed adopting universal doubt as the proper method to obtain certainty in philosophy. Thinkers as diverse as Thomas "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0341",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Reid")]), _vm._v(", David "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0182"
    }
  }, [_vm._v("Hume")]), _vm._v(" and Søren "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0219"
    }
  }, [_vm._v("Kierkegaard")]), _vm._v(", on the other hand, have agreed that universal doubt is impossible (and would be incurable if it "), _c('em', [_vm._v("were")]), _vm._v(" possible). Though doubt is properly seen as opposed to "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0139"
    }
  }, [_vm._v("faith")]), _vm._v(" or "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0037"
    }
  }, [_vm._v("belief")]), _vm._v(", it seems possible for a healthy, living faith (understood as trust) to coexist with some kinds of doubt, as in “I believe; help my unbelief” (Mk 9:24).")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0113"
    }
  }, [_c('strong', [_vm._v("dualism.")]), _vm._v(" Any philosophical theory that posits two distinct primary substances or that is built around a fundamental distinction between two elements. The term is used in a variety of contexts to designate entirely different kinds of theories. For example, ancient "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0241",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Manichaeism")]), _vm._v(" was a form of dualism postulating two equal but opposing divine realities, a good power of light and an evil power of darkness. "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0393",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Theism")]), _vm._v(" has a dualistic dimension in that it makes a clear distinction between God and the created order, between the infinite and the finite. Theories positing that the mind (or soul) and the body are distinct substances are also referred to as dualisms, though there are important differences among Platonic, Thomistic and Cartesian forms of mind-body dualism.")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0114"
    }
  }, [_c('strong', [_vm._v("Duns Scotus, John (c. 1265-1308).")]), _vm._v(" Scottish philosopher and theologian, one of the leading figures of "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0358",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Scholasticism")]), _vm._v(". Scotus was a Franciscan who lectured at Oxford, Paris and Cologne. Called “the subtle doctor,” Scotus synthesized the insights of "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0028"
    }
  }, [_vm._v("Augustine")]), _vm._v(" with the newer thought in the tradition of "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0022"
    }
  }, [_vm._v("Aristotle")]), _vm._v(". He is well known for his conviction that God created individual essences, or “haecceities,” and for his defense of the role of "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0108"
    }
  }, [_vm._v("divine commands")]), _vm._v(" or decrees as part of the foundation of "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0130"
    }
  }, [_vm._v("ethics")]), _vm._v(". He taught that the human will has two natural motives: an “affection for advantage” and an “affection for justice.”")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0115"
    }
  }, [_c('strong', [_vm._v("Durkheim, Émile (1858-1917).")]), _vm._v(" French social scientist, one of the founders of modern empirical sociology and pioneer of the sociology of religion. Durkheim developed a naturalistic and functionalist approach to religion (and the rest of society) that sees religious beliefs and rituals as providing a set of unifying symbols that represent the core values of a society. One criticism often made of Durkheim’s theory of religion is that it does not seem to capture the universal aspects of the great world religions, which seem to transcend the values of any particular society.")]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "Letter_E"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/toc"
    }
  }, [_vm._v("E")])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse",
    attrs: {
      "id": "P0116"
    }
  }, [_c('strong', [_vm._v("ecofeminism.")]), _vm._v(" View that lack of concern for the environment is grounded in patriarchal attitudes, including religious constructs that divorce human beings from nature and regard nature as property to be used and managed. "), _c('em', [_vm._v("See also")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0117"
    }
  }, [_vm._v("ecological crisis")]), _vm._v("; "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0142"
    }
  }, [_vm._v("feminism")]), _vm._v("; "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0158"
    }
  }, [_vm._v("gender")]), _vm._v("; "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0302",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("patriarchy, matriarchy")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0117"
    }
  }, [_c('strong', [_vm._v("ecological crisis.")]), _vm._v(" Emergency precipitated by modern industrial societies, which appear to steadily diminish fresh air, water and unspoiled natural habitats for plants and animals. Historian Lynn White has argued that the ecological crisis is rooted in theistic religions that are anthropocentric and view humans as rulers and managers of the natural order. As a response, some theologians have moved toward "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0298",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("pantheism")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0296",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("panentheism")]), _vm._v(" and "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0014"
    }
  }, [_vm._v("animism")]), _vm._v(", which allegedly view nature as more sacred than does "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0393",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("theism")]), _vm._v(". Theists have responded that the idea of human stewardship does not logically imply that the environment can be spoiled but rather that people ought to care for God’s creation.")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0118"
    }
  }, [_c('strong', [_vm._v("Edwards, Jonathan (1703-1758).")]), _vm._v(" American philosopher and theologian who synthesized "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0123"
    }
  }, [_vm._v("Enlightenment")]), _vm._v(" scientific and philosophical ideas with historic Calvinism. Edwards’s thought is distinguished by commitments to George "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0038"
    }
  }, [_vm._v("Berkeley’s")]), _vm._v(" idealism, to "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0068"
    }
  }, [_vm._v("compatibilism")]), _vm._v(" with respect to freedom and determinism, and to an interesting view of God’s holiness as “the disinterested love of being” that constitutes “true beauty.” Edwards believed that a person must have a love for "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0035"
    }
  }, [_vm._v("beauty")]), _vm._v(" in this form in order to acquire religious "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0411",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("truth")]), _vm._v(", and thus he devoted much attention to the development of religious affections, or emotions. Edwards is also important as one of the founders of revivalism in North America.")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0119"
    }
  }, [_c('strong', [_vm._v("egoism.")]), _vm._v(" The theory that humans do or should seek only their own individual "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0165"
    }
  }, [_vm._v("happiness")]), _vm._v(". Psychological egoism holds that as a matter of fact people seek always and only their own good. Moral egoism holds that it is right or good that humans should act in this way. Ayn Rand’s novels provide a dramatic illustration and defense of egoism. Traditional Christian teaching, in contrast, has condemned universal egoism as a form of sinful selfishness, to be distinguished from a proper regard for one’s "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0363",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("self")]), _vm._v(" and its needs. "), _c('em', [_vm._v("See also")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0167"
    }
  }, [_vm._v("hedonism")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0120"
    }
  }, [_c('strong', [_vm._v("eliminative materialism.")]), _vm._v(" Form of "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0245",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("materialism")]), _vm._v(" that denies the existence of distinctively mental entities rather than seeing mental states as identical with or reducible to physical states. Thus an eliminative materialist might argue that in principle an ideal scientific account of the world would contain no reference to such mental entities as “beliefs” or “sensations.” The eliminative materialist, instead of arguing that entities such as “pains” are really just brain processes of a certain sort, claims that when science progresses we will be able to say that talk of what we used to call (confusedly and mistakenly) “pains” has been replaced by talk of appropriate types of brain processes.")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0121"
    }
  }, [_c('strong', [_vm._v("embodiment.")]), _vm._v(" A central theme of European "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0309",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("phenomenology")]), _vm._v(" that focuses on the body not merely as a physiological object but as "), _c('em', [_vm._v("my")]), _vm._v(" body—the body as experienced or lived. The term is also used by panentheists who reject the traditional theistic view of God as transcending the world and instead think of God as embodied in the natural order. "), _c('em', [_vm._v("See also")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0296",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("panentheism")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0122"
    }
  }, [_c('strong', [_vm._v("empiricism.")]), _vm._v(" Type of epistemological theory that, in contrast with epistemological "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0334",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("rationalism")]), _vm._v(", gives primacy to sense experience in the acquisition of "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0220"
    }
  }, [_vm._v("knowledge")]), _vm._v(". There are many types of empiricism. In the ancient world, "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0022"
    }
  }, [_vm._v("Aristotle")]), _vm._v(" was much more empiricist than was "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0315",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Plato")]), _vm._v(", who emphasized innate ideas. This same difference was reflected in medieval philosophers, some of whom were Platonists, while others, such as Thomas "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0020"
    }
  }, [_vm._v("Aquinas")]), _vm._v(", followed Aristotle more closely. In modern philosophy the British philosophers John "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0232"
    }
  }, [_vm._v("Locke")]), _vm._v(", George "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0038"
    }
  }, [_vm._v("Berkeley")]), _vm._v(" and David "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0182"
    }
  }, [_vm._v("Hume")]), _vm._v(" are the most significant empiricists. In the twentieth century "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0233"
    }
  }, [_vm._v("logical positivism")]), _vm._v(" and its successors represented the empiricist tradition. "), _c('em', [_vm._v("See also")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0124"
    }
  }, [_vm._v("epistemology")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0123"
    }
  }, [_c('strong', [_vm._v("Enlightenment.")]), _vm._v(" Eighteenth-century intellectual movement that emphasized the "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0030"
    }
  }, [_vm._v("autonomy")]), _vm._v(" of human "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0336",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("reason")]), _vm._v(" and questioned the role of traditional "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0029"
    }
  }, [_vm._v("authorities")]), _vm._v(". Immanuel "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0217"
    }
  }, [_vm._v("Kant")]), _vm._v(" and David "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0182"
    }
  }, [_vm._v("Hume")]), _vm._v(" were among the most important thinkers of the Enlightenment, though it included such individuals as Thomas Jefferson as well. Kant’s motto “Dare to use your own reason” expresses the attitude of the Enlightenment well. Kant and Hume both developed influential critiques of the rational grounds of religious belief, though Kant himself thought that in denying religious "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0220"
    }
  }, [_vm._v("knowledge")]), _vm._v(" he was making room for rational religious "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0139"
    }
  }, [_vm._v("faith")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0124"
    }
  }, [_c('strong', [_vm._v("epistemology.")]), _vm._v(" The branch of "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0311",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("philosophy")]), _vm._v(" concerned with questions about "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0220"
    }
  }, [_vm._v("knowledge")]), _vm._v(" and "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0037"
    }
  }, [_vm._v("belief")]), _vm._v(" and related issues such as "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0214"
    }
  }, [_vm._v("justification")]), _vm._v(" and "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0411",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("truth")]), _vm._v(". Some conceive of epistemology as an attempt to refute "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0368",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("skepticism")]), _vm._v(", the denial that knowledge is possible. One of the major debates in epistemology is that of internalism versus externalism: Must the basis or ground that warrants a belief be internally accessible to "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0073"
    }
  }, [_vm._v("consciousness")]), _vm._v("? Another major debate is "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0149"
    }
  }, [_vm._v("foundationalism")]), _vm._v(" versus "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0063"
    }
  }, [_vm._v("coherentism")]), _vm._v(": Are some beliefs “properly basic,” or are all beliefs based on other beliefs in an interconnected web? Some philosophers of religion have argued that critiques of religious belief as unreasonable are grounded in faulty epistemologies, theories of knowledge that if applied to fields other than religion would make knowledge impossible in those other fields as well.")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0125"
    }
  }, [_c('strong', [_vm._v("equivocal.")]), _vm._v(" Adjective that describes the status of a term when it is used in more than one sense in the course of an argument, so that the argument commits the logical fallacy of equivocation. Note the equivocal use of terms in the following humorous example: “I love you. Therefore I am a lover. All the world loves a lover. You are all the world to me. Therefore you love me.”")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0126"
    }
  }, [_c('strong', [_vm._v("eschatological verification.")]), _vm._v(" View that the truth or falsity of religious statements is capable of empirical verification—but only after death. John "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0173"
    }
  }, [_vm._v("Hick")]), _vm._v(" developed this view as a response to the logical positivist charge that religious propositions are cognitively meaningless because they are not empirically verifiable. "), _c('em', [_vm._v("See also")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0122"
    }
  }, [_vm._v("empiricism")]), _vm._v("; "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0233"
    }
  }, [_vm._v("logical positivism")]), _vm._v("; "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0221"
    }
  }, [_vm._v("language")]), _vm._v(", religious (theories of).")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0127"
    }
  }, [_c('strong', [_vm._v("eschatology.")]), _vm._v(" Branch of "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0397",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("theology")]), _vm._v(" that deals with the “last things,” or the end of history, including such topics as the second coming of Christ, the final "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0211"
    }
  }, [_vm._v("judgment")]), _vm._v(" and the nature of "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0166"
    }
  }, [_vm._v("heaven")]), _vm._v(" and "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0170"
    }
  }, [_vm._v("hell")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0128"
    }
  }, [_c('strong', [_vm._v("essentialism.")]), _vm._v(" Metaphysical view that there are real essences, or “natures,” in things. Objects have sets of properties that are essential to their being what they are, and these can be distinguished from those properties they have “accidentally” or contingently. An opposing view holds that essences are a function of language. According to this opposing view, the set of properties essential to an object is a function of how the object is being described rather than a real feature of the object. "), _c('em', [_vm._v("See also")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0249",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("metaphysics")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0129"
    }
  }, [_c('strong', [_vm._v("eternity/everlasting.")]), _vm._v(" Contrasting ways of thinking of God’s relation to "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0400",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("time")]), _vm._v(" as well as the nature of the life hoped for by Christians now and after death. There is a dispute between those who think of eternity as everlasting time, with no beginning or end, and those who conceive of eternity as an atemporal (timeless) mode of reality. Defenders of the notion of eternity as everlasting argue that this is the Hebraic concept and that the concept of a timeless eternity is a product of Greek thinking that distorts the biblical view. Defenders of timeless eternity argue that God is the Lord of time and that he could not create time without himself being timeless.")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0130"
    }
  }, [_c('strong', [_vm._v("ethics.")]), _vm._v(" Branch of "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0311",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("philosophy")]), _vm._v(" that concerns itself with questions of right and wrong, "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0163"
    }
  }, [_vm._v("good")]), _vm._v(" and "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0133"
    }
  }, [_vm._v("evil")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0417",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("virtues")]), _vm._v(" and vices. In addition, ethics deals with metaethical questions, such as “What does it mean to call an act ‘right’?” “What is the basis or foundation of rightness?” “What makes right acts right?” The dispute concerning consequentialist and "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0096"
    }
  }, [_vm._v("deontological")]), _vm._v(" ethical theories is one of the major areas of disagreement in ethics.")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0131"
    }
  }, [_c('strong', [_vm._v("Euthyphro dilemma.")]), _vm._v(" Dilemma inspired by an argument in "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0315",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Plato’s")]), _vm._v(" "), _c('em', [_vm._v("Euthyphro")]), _vm._v(" dialogue that is alleged to undermine "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0108"
    }
  }, [_vm._v("divine command theories")]), _vm._v(" in ethics. The key question is whether acts are right because God commands them or whether God commands certain acts because they are right. If one chooses the first option, it is alleged that moral rightness will be based on an arbitrary decision on God’s part and that it will then be meaningless to praise God as righteous. If one chooses the second horn of the dilemma, then it appears that what is right must be independent of God’s commands.")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0132"
    }
  }, [_c('strong', [_vm._v("evidentialism.")]), _vm._v(" The view that religious beliefs (as well as other kinds) are only "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0333",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("rational")]), _vm._v(" if they are based on evidence. Typically, evidentialists will specify some minimum of evidence that is sufficient (such as “evidence that makes a belief more probable than not” or “evidence that makes a belief more probable than its competitors”). Another popular form of evidentialism is a proportional “ethics of belief” that holds that the strength of one’s assent to a "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0037"
    }
  }, [_vm._v("belief")]), _vm._v(" should be proportioned to the strength of the evidence. This kind of ethic of belief can be traced to John "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0232"
    }
  }, [_vm._v("Locke")]), _vm._v(". Evidentialism has been strongly challenged by "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0339",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Reformed Epistemology")]), _vm._v(", particularly the work of Alvin "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0314",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Plantinga")]), _vm._v(" and Nicholas "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0426",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wolterstorff")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0133"
    }
  }, [_c('strong', [_vm._v("evil, nature of.")]), _vm._v(" The character of that which is opposed to "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0163"
    }
  }, [_vm._v("good")]), _vm._v(". Christians think of evil as what is opposed to the purposes of God. Most Christian theologians have held that evil is not a positive thing or substance but should be understood as a defect or damage to God’s creation. Though evil is not a substance, it does have a positive, active character in that it is rooted in the actions of free agents. The question of its character is therefore closely linked to questions about the nature of personal freedom and the relations between such creatures and their Creator.")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0134"
    }
  }, [_c('strong', [_vm._v("evil, problem of.")]), _vm._v(" Difficulty posed by the existence of "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0133"
    }
  }, [_vm._v("evil")]), _vm._v(" (both moral evil and natural evil) in a world created by a God who is both completely good and all-powerful. Some atheists argue that if such a God existed, there would be no evil, since God would both want to eliminate evil and would be able to do so. An argument that evil is logically incompatible with God’s reality forms the logical or deductive form of the problem. An argument that evil makes God’s existence unlikely or less likely is called the evidential or probabilistic form of the problem. Responses to the problem include theodicies, which attempt to explain why God allows evil, usually by specifying some greater good that evil makes possible, and defenses, which argue that it is reasonable to believe that God is justified in allowing evil, even if we do not know what his reasons are. "), _c('em', [_vm._v("See also")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0152"
    }
  }, [_vm._v("free will defense")]), _vm._v("; "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0396",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("theodicy")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0135"
    }
  }, [_c('strong', [_vm._v("evolution, theory of.")]), _vm._v(" Theory that life forms have altered or evolved over time. Microevolution is development within a species and is uncontroversial. Macroevolution is the theory that various life forms have evolved from simpler life forms, often coupled with a theory of common descent that claims all forms of biological life have evolved from one simple organism. Though various evolutionary theories have been developed, the most common theories today are neo-Darwinian. "), _c('em', [_vm._v("See also")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0084"
    }
  }, [_vm._v("creationism")]), _vm._v("; "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0090"
    }
  }, [_vm._v("Darwinism")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0136"
    }
  }, [_c('strong', [_vm._v("exclusivism.")]), _vm._v(" Within Christian "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0397",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("theology")]), _vm._v(", the view that "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0354",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("salvation")]), _vm._v(" is possible (at least for adults since the time of Christ) only for those who explicitly have faith in Jesus. This view is contrasted with inclusivism, which holds that, though people can only be saved through Christ, it is possible that some who lack explicit faith in Christ in this life will be saved by him, and pluralism, which holds that Jesus is not the only means of salvation. More broadly, the term is used for any religious view that holds that salvation is possible only through that particular religion.")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0137"
    }
  }, [_c('strong', [_vm._v("existentialism.")]), _vm._v(" Cluster of philosophies popular after World War II that stressed that human existence is constituted by the choices people make. Existentialists had no agreed-upon body of beliefs but tended to stress the freedom, precariousness and even absurdity of the human situation, along with the responsibility of the individual to define herself or himself through action. Though existentialism was inspired by nineteenth-century thinkers Søren "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0219"
    }
  }, [_vm._v("Kierkegaard")]), _vm._v(" and Friedrich "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0274",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Nietzsche")]), _vm._v(", neither of these philosophers would have endorsed much of what passed as existentialism. There were both atheistic (Jean Paul "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0355",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sartre")]), _vm._v(" and Albert "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0048"
    }
  }, [_vm._v("Camus")]), _vm._v(") and religious (Martin "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0042"
    }
  }, [_vm._v("Buber")]), _vm._v(" and Gabriel-Honoré "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0242",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Marcel")]), _vm._v(") versions, but in the popular mind existentialism is seen as atheistic.")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0138"
    }
  }, [_c('strong', [_vm._v("experience of God.")]), _vm._v(" "), _c('em', [_vm._v("see")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0344",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("religious experience")]), _vm._v(".")]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "Letter_F"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/toc"
    }
  }, [_vm._v("F")])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse",
    attrs: {
      "id": "P0139"
    }
  }, [_c('strong', [_vm._v("faith.")]), _vm._v(" Within Christianity, that attitude of trust in God, including beliefs about God and his goodness, that is essential to a right relationship with God. Many theologians regard faith as including various dimensions, including trust, propositional "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0037"
    }
  }, [_vm._v("belief")]), _vm._v(" and a willingness to act obediently. More loosely, the term is used for any set of religious commitments or even secular commitments, as with the person who has “faith” in psychoanalysis or Marxism. Also used as a synonym for "), _c('em', [_vm._v("religion,")]), _vm._v(" as in “the world’s major faiths.”")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0140"
    }
  }, [_c('strong', [_vm._v("Fall, the.")]), _vm._v(" For traditional Christians, the disobedience of Adam and Eve, the parents of the human race, which plunged humanity into "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0367",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("sin")]), _vm._v(" and death and led to the marring of God’s originally good creation. Many contemporary theologians view the story of the Fall as a myth, considering the narrative to be a pictorial description of the human condition rather than a description of a historical event.")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0141"
    }
  }, [_c('strong', [_vm._v("fatalism.")]), _vm._v(" The view that whatever happens does so necessarily and that therefore human choice and effort make no difference. Critics of "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0101"
    }
  }, [_vm._v("determinism")]), _vm._v(" allege that fatalism is a logical consequence of determinism, but most determinists (particularly so-called “soft determinists”) reject this on the grounds that human choices do make a difference as part of the causal order. Some “hard determinists” accept the idea that whatever happens does so necessarily and claim that recognizing this truth frees a person from anxiety and leads to peace of mind.")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0142"
    }
  }, [_c('strong', [_vm._v("feminism.")]), _vm._v(" Way of thinking that makes the differential experiences of men and women fundamental to its conclusions and methods. Feminists argue that much traditional scholarship in many fields reflects an unconscious male bias, adding that when theorizing takes account of women’s interests and identities, it can help overcome these problems. It is important to distinguish among various forms of feminism, such as liberal feminism, socialist feminism and so-called radical feminism. Though many feminists are stridently anti-Christian and even antireligious, some feminists are committed Christians who argue that a concern for women’s well-being is grounded in Christian views of equality. "), _c('em', [_vm._v("See also")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0158"
    }
  }, [_vm._v("gender")]), _vm._v("; "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0302",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("patriarchy, matriarchy")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0143"
    }
  }, [_c('strong', [_vm._v("Feuerbach, Ludwig (1804-1872).")]), _vm._v(" German philosopher who developed the projection theory of religion in which God is understood as a projection of unfulfilled human potential. Thus, according to this theory, religion is really anthropology. Feuerbach was a materialist who had a strong influence on Karl "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0243",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Marx")]), _vm._v(". Feuerbach held that human progress demands a demystification of the religious consciousness and a return to concrete problems of human existence.")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0144"
    }
  }, [_c('strong', [_vm._v("fideism.")]), _vm._v(" The view that "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0139"
    }
  }, [_vm._v("faith")]), _vm._v(" takes precedence over "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0336",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("reason")]), _vm._v(". The word is often used as a term of abuse to designate a view considered by a critic to be a form of irrationalism. "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0392",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tertullian")]), _vm._v(" and Søren "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0219"
    }
  }, [_vm._v("Kierkegaard")]), _vm._v(" are often cited as fideists.")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0145"
    }
  }, [_c('strong', [_vm._v("finitude.")]), _vm._v(" Those limitations in the natural order that are to be ascribed to creatureliness rather than to "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0367",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("sin")]), _vm._v(". Thus sin itself must be understood not merely as a defect due to finitude but to a willful turning away from God. Being finite with respect to moral insight or will does not constitute sin; willful failure to follow a moral insight, however, cannot merely be ascribed to finitude.")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0146"
    }
  }, [_c('strong', [_vm._v("first cause.")]), _vm._v(" "), _c('em', [_vm._v("see")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0079"
    }
  }, [_vm._v("cosmological arguments")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0147"
    }
  }, [_c('strong', [_vm._v("Five Ways.")]), _vm._v(" "), _c('em', [_vm._v("See")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0020"
    }
  }, [_vm._v("Aquinas")]), _vm._v(", Thomas.")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0148"
    }
  }, [_c('strong', [_vm._v("foreknowledge, divine.")]), _vm._v(" God’s knowledge of future events, including future free human choices. Some philosophers argue that since God’s knowledge cannot be mistaken, and since the past cannot be changed, God’s knowing future events before they occur implies that no other events could possibly occur and that "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0151"
    }
  }, [_vm._v("free will")]), _vm._v(" is an illusion (the "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0101"
    }
  }, [_vm._v("determinism")]), _vm._v(" viewpoint). A variety of responses to this problem have been given, including holding that since God is timeless he has no knowledge "), _c('em', [_vm._v("before")]), _vm._v(" an event but knows all things in a timeless now. Others accept Molinism, the view that God’s foreknowledge and "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0330",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("providence")]), _vm._v(" are linked to his "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0250",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("middle knowledge")]), _vm._v(", which is a knowledge of how free creatures would act in different circumstances. Still others limit God’s foreknowledge by holding that, while "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0285",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("omniscience")]), _vm._v(" includes knowing all true or false propositions, some propositions about the future are as of yet neither true nor false. And similarly, others limit divine foreknowledge by holding that, while God knows all that it is logically possible to know, it is logically impossible to have infallible prior knowledge of free decisions.")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0149"
    }
  }, [_c('strong', [_vm._v("foundationalism.")]), _vm._v(" Type of "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0124"
    }
  }, [_vm._v("epistemology")]), _vm._v(" holding that though many "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0037"
    }
  }, [_vm._v("beliefs")]), _vm._v(" are based on other beliefs, some beliefs must be held in a basic or foundational manner in order to avoid an infinite regress of beliefs. Classical foundationalism held that basic beliefs must be highly certain (self-evident or experientially certain) to be properly held, while some contemporary foundationalists, such as advocates of "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0339",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Reformed Epistemology")]), _vm._v(", accept the fallibility of basic beliefs. "), _c('em', [_vm._v("See also")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0150"
    }
  }, [_vm._v("foundationalism, classical")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0150"
    }
  }, [_c('strong', [_vm._v("foundationalism, classical.")]), _vm._v(" Type of "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0124"
    }
  }, [_vm._v("epistemology")]), _vm._v(" that was predominant in early modern philosophy through the "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0123"
    }
  }, [_vm._v("Enlightenment")]), _vm._v(". As a version of foundationalism, this type of epistemology holds that "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0037"
    }
  }, [_vm._v("beliefs")]), _vm._v(" must be grounded on basic or foundational beliefs. However, classical foundationalism is distinguished from such fallibilist epistemologies as "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0339",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Reformed Epistemology")]), _vm._v(" by the claim that foundational beliefs must be highly certain. Rationalist versions held that the foundational beliefs must be self-evidently true, while empiricists accepted propositions that are “incorrigible” because they are evident to the senses as possessing the requisite degree of certainty. Many philosophers today are convinced that the ideal of classical foundationalism cannot be attained and that as a consequence we must either become "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0368",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("skeptics")]), _vm._v(" or else embrace some alternative epistemology, such as a nonfoundationalist "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0063"
    }
  }, [_vm._v("coherentism")]), _vm._v(" or a fallibilist version of foundationalism.")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0151"
    }
  }, [_c('strong', [_vm._v("free will.")]), _vm._v(" The ability of an agent to make genuine choices that stem from the "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0363",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("self")]), _vm._v(". Libertarians argue that free will includes the power to determine the will itself, so that a person with free will can will more than one thing. Compatibilists typically view free will as the power to act in accordance with one’s own will rather than being constrained by some external cause, allowing that the will itself may ultimately be causally determined by something beyond the self. Hard determinists deny the existence of free will altogether. Most Christian theologians agree that humans possess free will in some sense but disagree about what kind of freedom is necessary. The possession of free will does not entail an ability not to "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0367",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("sin")]), _vm._v(", since human freedom is shaped and limited by human "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0056"
    }
  }, [_vm._v("character")]), _vm._v(". Thus a human person may be free to choose among possibilities in some situations but still be unable to avoid all sin. "), _c('em', [_vm._v("See also")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0068"
    }
  }, [_vm._v("compatibilism")]), _vm._v("; "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0101"
    }
  }, [_vm._v("determinism")]), _vm._v("; "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0229"
    }
  }, [_vm._v("libertarianism (metaphysical")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0152"
    }
  }, [_c('strong', [_vm._v("free will defense.")]), _vm._v(" Response to the problem of "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0133"
    }
  }, [_vm._v("evil")]), _vm._v(" arguing that God may be justified in allowing evil because the possibility of evil is logically inherent in "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0151"
    }
  }, [_vm._v("free will")]), _vm._v(". If free will is a great "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0163"
    }
  }, [_vm._v("good")]), _vm._v(" that makes possible other great goods, then these goods might provide a sufficient reason for God allowing evil. Since not even omnipotence can do what is logically impossible, God must accept the possibility of evil if he wishes to give some of his creatures free will. "), _c('em', [_vm._v("See also")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0396",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("theodicy")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0153"
    }
  }, [_c('strong', [_vm._v("Freud, Sigmund (1856-1939).")]), _vm._v(" Austrian physician and psychological theorizer, founder of psychoanalysis. In "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0312",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("philosophy of religion")]), _vm._v(", Freud is known for his theory that belief in God is an illusion that arises out of the Oedipal complex, in which a child has a relation to what appears to the child to be an all-powerful father, on whom the child is dependent and whose good will the child desires. Freud does not appear to have noticed that his psychological theory, which holds that the child also resents and envies the powerful father, could provide an equally reductionistic explanation of antireligious beliefs. Nor did he consider the possibility that the child’s relation to the parents, rather than being a mechanism for the formation of an illusion, could be a divinely ordained model whereby God provides a conception of himself.")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0154"
    }
  }, [_c('strong', [_vm._v("functionalism.")]), _vm._v(" The view that mental states are not defined by their intrinsic qualities but by their relations to other states, particularly causal relations. A functionalist would not thereby define a mental state dualistically as a spiritual event nor materialistically as a brain process but would rather say that a mental state is simply a state that plays a certain functional role in an organism’s life. Mental states are those that are caused by certain inputs from the environment, which in turn cause certain behaviors, and that also enjoy certain relations with other inner states. (The latter type of relation is one factor that distinguishes functionalism from "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0036"
    }
  }, [_vm._v("behaviorism")]), _vm._v(".) In theory a functionalist could be a dualist, but in reality most functionalists about the human mind are physicalists who believe that material states satisfy the functional roles. "), _c('em', [_vm._v("See also")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0113"
    }
  }, [_vm._v("dualism")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0155"
    }
  }, [_c('strong', [_vm._v("fundamentalism.")]), _vm._v(" Originally a term that designated the movement associated with a group of books written by distinguished theologians in the early part of the twentieth century defending the fundamentals of the Christian faith, especially the deity of Christ. Over time the term has taken on a broader sense, becoming associated with any form of traditional, conservative Christianity and even with traditional and conservative forms of other religions, as in “Muslim fundamentalists.” When used in this broader way, the term is often employed in a derogatory manner, with connotations of anti-intellectualism. As a result, conservative Christians often prefer to distinguish their own views from those of fundamentalism, such as by asserting, “I am an evangelical [or ‘traditional Christian’ or ‘neoevangelical’], not a fundamentalist.”")]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "Letter_G"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/toc"
    }
  }, [_vm._v("G")])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse",
    attrs: {
      "id": "P0156"
    }
  }, [_c('strong', [_vm._v("Gadamer, Hans-Georg (1900-2002).")]), _vm._v(" German philosopher who developed a philosophical hermeneutic that sees interpretation as a fundamental dimension to human existence. Gadamer, who was a student of Martin "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0169"
    }
  }, [_vm._v("Heidegger")]), _vm._v(", criticizes the "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0123"
    }
  }, [_vm._v("Enlightenment")]), _vm._v(" for its “prejudice against prejudices” and argues that understanding requires us to grasp a text against a “horizon of meaning” provided by a tradition. The interpreter brings to the encounter his or her own horizon of meaning, and genuine understanding occurs when there is a “fusion of horizons.”")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0157"
    }
  }, [_c('strong', [_vm._v("Galileo Galilei (1564-1642).")]), _vm._v(" Italian astronomer and physicist and one of the great early modern scientists. Galileo invented the modern science of mechanics and defended Copernicus’s theory that the sun is the center of the solar system. He was called before the Inquisition and forced to recant his views. This episode is often cited as evidence of the conflict between religion and "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0359",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("science")]), _vm._v(". However, it is noteworthy that Galileo was himself deeply religious and even gave theological justifications for his approach to science.")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0158"
    }
  }, [_c('strong', [_vm._v("gender.")]), _vm._v(" Originally a term for the grammatical structure of many languages, in which nouns are designated either as masculine or feminine (or neuter, in some languages). Feminist theorists have seized on the word as a term for the way in which sexual differences can be understood not as a biological necessity but as a cultural construction. Thus feminists argue that much traditional scholarship, including theology and philosophy, has reflected a masculine, gender-biased viewpoint that has not taken adequate account of women’s experiences and interests. "), _c('em', [_vm._v("See also")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0142"
    }
  }, [_vm._v("feminism")]), _vm._v("; "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0302",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("patriarchy, matriarchy")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0159"
    }
  }, [_c('strong', [_vm._v("general revelation.")]), _vm._v(" Term used for the knowledge about God that he makes possible through the natural world, including general religious experiences of awe and dependence. Defenders of general revelation have usually claimed that it is sufficient only to give us knowledge of the existence of a powerful Creator, though some have argued that the goodness of God can also be seen in the natural order. General revelation is distinguished from the "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0378",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("special revelation")]), _vm._v(" God has provided on particular occasions in history through prophets, apostles and supremely (for Christians) Jesus of Nazareth. Special revelation provides more concrete knowledge of the character and actions of God in relation to his creation. "), _c('em', [_vm._v("See also")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0348",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("revelation")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0160"
    }
  }, [_c('strong', [_vm._v("Gnosticism.")]), _vm._v(" A religious movement popular in the second and third centuries of the Christian church. Gnosticism’s influence can be seen in various Christian heresies and in Christian polemics against the movement’s tendencies. Gnostics believed in the possibility of a higher level of spiritual "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0220"
    }
  }, [_vm._v("knowledge")]), _vm._v(", or "), _c('em', [_vm._v("gnosis,")]), _vm._v(" and recommended various means of achieving this higher spiritual state. Gnostics tended to depreciate the material world in favor of the higher spiritual world. The term is often used more loosely to refer to religious movements of any time period that emphasize esoteric spiritual knowledge.")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0161"
    }
  }, [_c('strong', [_vm._v("God.")]), _vm._v(" Divine being or beings who are the object of religious "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0428",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("worship")]), _vm._v(" or awe. Theists conceive of God as one being who created all things other than himself and who possesses a supremely good set of attributes, such as "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0283",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("omnipotence")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0284",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("omnipresence")]), _vm._v(" and "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0285",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("omniscience")]), _vm._v(", though Christian theists affirm that this one God exists in three persons. Polytheists believe there are multiple divine beings who have supernatural powers but lack the perfections of the God of "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0393",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("theism")]), _vm._v(". Pantheists view God as identical with the natural universe, while panentheists typically see God’s relation to the natural world as one of "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0121"
    }
  }, [_vm._v("embodiment")]), _vm._v(". "), _c('em', [_vm._v("See also")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0027"
    }
  }, [_vm._v("attributes of God")]), _vm._v("; "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0107"
    }
  }, [_vm._v("divine attributes")]), _vm._v("; "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0298",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("pantheism")]), _vm._v("; "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0296",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("panentheism")]), _vm._v("; "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0319",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("polytheism")]), _vm._v("; "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0393",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("theism")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0162"
    }
  }, [_c('strong', [_vm._v("God-of-the-gaps argument.")]), _vm._v(" A type of argument that invokes God as an explanation for what cannot be explained naturally or scientifically. Critics of this style of argument claim that such a strategy will inevitably make God’s role in the universe appear to diminish as scientific explanation advances. Critics of the "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0204"
    }
  }, [_vm._v("intelligent design")]), _vm._v(" movement allege that the attempt to argue for an intelligent cause of biological order is a God-of-the-gaps argument, but proponents of intelligent design argue that there is positive empirical evidence for intelligence as the cause of complex systems in nature.")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0163"
    }
  }, [_c('strong', [_vm._v("good, the.")]), _vm._v(" The most general term of ethical approval. The good is that which has positive value—for humans, that which is constitutive of, or conducive to, human flourishing. “Good” has both a moral sense, in which it is the opposite of "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0133"
    }
  }, [_vm._v("evil")]), _vm._v(", and a nonmoral sense, in which it is the opposite of that which is bad in any sense. Many ethical theories are grounded in a theory of the good, an example being that of the hedonist who identifies the good with pleasure. Theists typically hold that the good is in some way linked to God, who is supremely good. For Platonists, the Good is the supreme Form, the One from whom all being and value is derived, and Christian Platonists have naturally identified the Good with God. "), _c('em', [_vm._v("See also")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0130"
    }
  }, [_vm._v("ethics")]), _vm._v("; "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0259",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("morality")]), _vm._v("; "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0272",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Platonism")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0164"
    }
  }, [_c('strong', [_vm._v("grace.")]), _vm._v(" Traditionally understood by Christians as the unmerited favor of God extended toward his creation and particularly toward humans. Christians think of God’s grace as preeminently extended to humans in Jesus’ incarnation, death and resurrection, by which God atones for sin and makes possible eternal life with himself. "), _c('em', [_vm._v("See also")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0065"
    }
  }, [_vm._v("common grace")]), _vm._v(".")]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "Letter_H"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/toc"
    }
  }, [_vm._v("H")])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse",
    attrs: {
      "id": "P0165"
    }
  }, [_c('strong', [_vm._v("happiness.")]), _vm._v(" The intrinsically good state of life regarded as supremely worth having. The ancient Greeks tended to agree that happiness, or "), _c('em', [_vm._v("eudaimonia,")]), _vm._v(" is the end or goal of the ethical life, while disagreeing about the nature of happiness and how to achieve it. Broadly speaking, "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0022"
    }
  }, [_vm._v("Aristotle")]), _vm._v(" tended to think of happiness as consisting mainly of activities. In other words, the happy person is the one who flourishes by actualizing his or her human potential. Hedonists think of happiness more as a life of pleasant experiences. Christians tend to link true happiness with the blessedness found in knowing God. "), _c('em', [_vm._v("See also")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0034"
    }
  }, [_vm._v("Beatific Vision")]), _vm._v("; "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0167"
    }
  }, [_vm._v("hedonism")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0166"
    }
  }, [_c('strong', [_vm._v("heaven.")]), _vm._v(" In Christian "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0397",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("theology")]), _vm._v(", the final state of those who know God and are blissfully united to him in Christ. Though there are many images of heaven employed in Scripture, most theologians agree that humans are at present incapable of understanding the nature of heavenly existence. "), _c('em', [_vm._v("See also")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0170"
    }
  }, [_vm._v("hell")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0167"
    }
  }, [_c('strong', [_vm._v("hedonism.")]), _vm._v(" The ethical theory that identifies the "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0163"
    }
  }, [_vm._v("good")]), _vm._v(" with "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0165"
    }
  }, [_vm._v("happiness")]), _vm._v(" and understands happiness as the presence of pleasure and the absence of "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0294",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("pain")]), _vm._v(". Critics of hedonism argue that the hedonist confuses what is a byproduct and concomitant of the good with the good itself; we do not seek pleasure primarily, but we seek good things (love and friendship, for example) that give us pleasure. If we did not value those things intrinsically, they would not in fact give us pleasure at all. "), _c('em', [_vm._v("See also")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0119"
    }
  }, [_vm._v("egoism")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0168"
    }
  }, [_c('strong', [_vm._v("Hegel, Georg Wilhelm Friedrich (1770-1831).")]), _vm._v(" German philosopher who developed a philosophical system called Absolute Idealism. In this system the whole of reality is seen as the progressive unfolding of an Absolute Mind (identified with God), achieved through a dialectical process in which "), _c('em', [_vm._v("Geist")]), _vm._v(" (Spirit or Mind) repeatedly becomes alienated from itself and then overcomes that negation in a higher unity. Hegel saw human history as the place where the Absolute becomes self-conscious, and he saw the modern liberal state as the highest form of Spirit, an ethical community in which art, religion and philosophy—the three forms of Absolute Spirit—can flourish. Both Karl "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0243",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Marx")]), _vm._v(" and Søren "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0219"
    }
  }, [_vm._v("Kierkegaard")]), _vm._v(" reacted critically against Hegel while at the same time being influenced by him in many ways.")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0169"
    }
  }, [_c('strong', [_vm._v("Heidegger, Martin (1889-1976).")]), _vm._v(" German philosopher whose life’s work centered on the question of the meaning of being. After early training in theology, Heidegger switched to philosophy to study with phenomenologist Edmund "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0183"
    }
  }, [_vm._v("Husserl")]), _vm._v(". His famous early work "), _c('em', [_vm._v("Being and Time")]), _vm._v(" attempted to discern the meaning of being by looking at human being "), _c('em', [_vm._v("(dasein)")]), _vm._v("—that being whose very being involves the question of being and who must resolutely face up to the temporality implied by a person’s own death. In his later writings, Heidegger changed his focus toward a mode of philosophizing in which the “call of Being” that has been repressed by technology and instrumental thinking can perhaps be discerned in the poet and the work of art. Heidegger had a great influence on "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0137"
    }
  }, [_vm._v("existentialism")]), _vm._v(", though he repudiated the uses the existentialists made of his work. His embrace of National Socialism has made him a controversial figure, though he remains influential, especially for "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0322",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("postmodern")]), _vm._v(" philosophers.")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0170"
    }
  }, [_c('strong', [_vm._v("hell.")]), _vm._v(" The final state of the damned, those who are separated from God. Many philosophical controversies center around hell, notably the questions posed for "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0396",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("theodicy")]), _vm._v(" by the existence of hell. While hell has traditionally been conceived of as a place of unending, conscious torment, some hold that those who are truly separated from God are annihilated, since to be cut off from God completely is to escape being. Thinkers such as C. S. "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0226"
    }
  }, [_vm._v("Lewis")]), _vm._v(" have suggested that hell is primarily a consequence of choice rather than a retributive punishment. The final mercy of God’s love allows those for whom God’s presence would be sheer torment to escape from that presence, though this is a fate that is horrible beyond description for those who understand the good that is thereby lost. "), _c('em', [_vm._v("See also")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0166"
    }
  }, [_vm._v("heaven")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0171"
    }
  }, [_c('strong', [_vm._v("henotheism.")]), _vm._v(" A religious perspective that ascribes supremacy, or at least supreme loyalty, to one deity (or “high god”) while recognizing the existence of other gods. "), _c('em', [_vm._v("See also")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0319",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("polytheism")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0172"
    }
  }, [_c('strong', [_vm._v("hermeneutics.")]), _vm._v(" Traditionally the subdiscipline of "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0397",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("theology")]), _vm._v(" concerned with the proper interpretation of scriptural texts. In the nineteenth and twentieth centuries, the term widened to include the discipline that seeks to understand the interpretation of texts in general, including the proper roles and relationships among author, reader and text. Still more broadly, the term has been used by philosophers such as Hans-Georg "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0156"
    }
  }, [_vm._v("Gadamer")]), _vm._v(" and Paul "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0349",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ricoeur")]), _vm._v(" to refer to the attempt to articulate the nature of understanding itself, with an emphasis on the role of interpretation as a key component in all human knowing. Here the interpretation of texts, with the taken-for-granted horizons of meaning that reading presupposes, becomes a metaphor for human understanding in general, and such things as human lives themselves are seen as “texts” or text analogues.")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0173"
    }
  }, [_c('strong', [_vm._v("Hick, John (1922-2012).")]), _vm._v(" Influential philosopher of religion, whose views have shifted toward a pluralistic view of the world’s religions. Earlier in his career Hick defended the "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0062"
    }
  }, [_vm._v("cognitive")]), _vm._v(" meaningfulness of religious "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0221"
    }
  }, [_vm._v("language")]), _vm._v(" over against "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0233"
    }
  }, [_vm._v("logical positivism")]), _vm._v(" and developed an influential “soul-making” "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0396",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("theodicy")]), _vm._v(". More recently, Hick has argued that each of the world’s religions represents a culturally conditioned response to “the Real” and that one cannot pragmatically judge one religion as superior to others. In Christian theology Hick has argued that the "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0195"
    }
  }, [_vm._v("incarnation")]), _vm._v(" of Jesus cannot be literally true. "), _c('em', [_vm._v("See also")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0344",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("religious")]), _vm._v(" pluralism.")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0174"
    }
  }, [_c('strong', [_vm._v("Hildegard of Bingen (1098-1179).")]), _vm._v(" Theologian, musician and artist of the medieval period whose thought and music are receiving renewed attention. Hildegard’s life and writings were marked by great originality and a deep "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0261",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("mysticism")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0175"
    }
  }, [_c('strong', [_vm._v("Hinduism.")]), _vm._v(" The dominant religious perspective of India, which is defined by the "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0029"
    }
  }, [_vm._v("authority")]), _vm._v(" of the religious writings called the Vedas and the Upanishads. Hinduism is more a group of religious traditions than a single religious faith, since within Hinduism one can find both theistic and monistic views of God and profound disagreements about such things as the nature of "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0307",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("personal")]), _vm._v(" identity. Generally, Hinduism is characterized by an acceptance of the doctrine of "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0342",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("reincarnation")]), _vm._v(", or transmigration of the soul, and the goal of the religious devotee is seen as the deliverance of the soul from the cycle of reincarnation. "), _c('em', [_vm._v("See also")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0256",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("monism")]), _vm._v("; "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0393",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("theism")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0176"
    }
  }, [_c('strong', [_vm._v("historical Jesus.")]), _vm._v(" The reconstructed portrait that is the goal of historical study dealing with Jesus of Nazareth. Beginning in the late eighteenth century and continuing through the present, with some starts and stops, there has proceeded a movement called the quest for the historical Jesus, an attempt to recover by objective historical inquiry the so-called Jesus of history, who is presumed to have been distorted by church dogma. The “historical Jesus” is sometimes contrasted with the theologically interpreted “Christ of faith,” but the church has always affirmed the historicity of the Christ it worships, and it thus has good reasons to welcome genuine historical study. It is, however, unlikely that any historical portrait will not in some ways reflect the “faith” of the historian constructing the portrait.")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0177"
    }
  }, [_c('strong', [_vm._v("Hobbes, Thomas (1588-1679).")]), _vm._v(" English philosopher best known for his political thought, though he also developed a mechanistic, deterministic, materialistic metaphysic and an empiricist epistemology. In his "), _c('em', [_vm._v("Leviathan")]), _vm._v(" Hobbes developed a form of social contract theory, in which humans give up the rights they have in the state of nature, where life is “solitary, poor, nasty, brutish and short,” and create a commonwealth by assigning those rights to a sovereign. The sovereign determines what is just and unjust, and thus the sovereign itself (a person or group) cannot be unjust. "), _c('em', [_vm._v("See also")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0122"
    }
  }, [_vm._v("empiricism")]), _vm._v("; "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0124"
    }
  }, [_vm._v("epistemology")]), _vm._v("; "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0245",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("materialism")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0178"
    }
  }, [_c('strong', [_vm._v("holiness.")]), _vm._v(" That quality of God and of things and persons set apart for God that marks whatever possesses it as “different” and “other” than the ordinary things of creation. Thus, when Moses met God at the burning bush, he was afraid and was told to remove his sandals, because the place was holy. In the New Testament, holiness increasingly took on the characteristics of righteousness and moral purity. The Holiness Movement is made up of those churches, especially in the Wesleyan tradition, that put a special emphasis on sanctification as a distinct work of "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0164"
    }
  }, [_vm._v("grace")]), _vm._v(". "), _c('em', [_vm._v("See also")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0259",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("morality")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0179"
    }
  }, [_c('strong', [_vm._v("holism.")]), _vm._v(" A term used in "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0124"
    }
  }, [_vm._v("epistemology")]), _vm._v(" for theories of meaning and justification that emphasize systemic interconnections. Theories that view meaning as determined by the relations that concepts have to each other, rather than by the referential relation of language to extralinguistic reality, are often called holistic. Coherentist, nonfoundationalist accounts of justification are also referred to as holistic. "), _c('em', [_vm._v("(see")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0063"
    }
  }, [_vm._v("coherentism")]), _vm._v("; "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0149"
    }
  }, [_vm._v("foundationalism")]), _vm._v(".) In both cases the image of a web is often used, with meaning or justification said to be a function of the place occupied in the web of concepts or web of beliefs.")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0180"
    }
  }, [_c('strong', [_vm._v("hope.")]), _vm._v(" One of the primary Christian "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0417",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("virtues")]), _vm._v(", along with "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0139"
    }
  }, [_vm._v("faith")]), _vm._v(" and "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0235"
    }
  }, [_vm._v("love")]), _vm._v(". Hope is a positive expectation of some future good that is not yet present and where there is some uncertainty, at least about the time when that good will be realized. Hope seems epistemologically weaker than "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0037"
    }
  }, [_vm._v("belief")]), _vm._v(", since one can hope for an event that one does not believe will occur. Some philosophers have proposed that hope might replace belief as a key element in faith, making faith easier to justify as reasonable. Biblically, however, it appears that faith and hope are linked. We hope for the coming of God’s kingdom because of our trust in God, and this trust includes beliefs about God’s reality and goodness as well as beliefs about God’s actions in Jesus.")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0181"
    }
  }, [_c('strong', [_vm._v("humanism.")]), _vm._v(" A view that assigns a special place and value to human beings and their activities and achievements. Originally, the term was used to denote a movement associated with the development and flourishing of the humanities—those disciplines that deal with human nature and human achievements, such as literature, philosophy and the arts. In the nineteenth century, however, the term was co-opted by Auguste Comte for his “religion of humanity,” which he developed as a secular replacement for traditional religious faith. The term continues to be used in this way, as in the "), _c('em', [_vm._v("Humanist Manifesto")]), _vm._v(". However, there is also a rich tradition of Christian humanism. Many Christian humanists are convinced that only in a religious "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0427",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("worldview")]), _vm._v(" is the value of human life really understood and safeguarded.")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0182"
    }
  }, [_c('strong', [_vm._v("Hume, David (1711-1776).")]), _vm._v(" Scottish philosopher who was one of the preeminent thinkers of the "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0123"
    }
  }, [_vm._v("Enlightenment")]), _vm._v(". Hume was an empiricist who claimed that all knowledge of “matters of fact” (any knowledge not grounded in the meanings of terms) is based on sense experience. ("), _c('em', [_vm._v("See")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0122"
    }
  }, [_vm._v("empiricism")]), _vm._v(".) Hume developed powerful arguments that our knowledge of cause and effect and reliance on "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0197"
    }
  }, [_vm._v("inductive reasoning")]), _vm._v(" are not in themselves rationally justifiable but are based on “custom.” In "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0312",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("philosophy of religion")]), _vm._v(", Hume is famous, first, for his argument that belief in "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0252",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("miracles")]), _vm._v(" is irrational because the evidence of past experience will always outweigh the testimony in favor of miracles, and second, for a powerful critique of "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0264",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("natural theology")]), _vm._v(" in his "), _c('em', [_vm._v("Dialogues Concerning Natural Religion.")])]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0183"
    }
  }, [_c('strong', [_vm._v("Husserl, Edmund (1859-1938).")]), _vm._v(" German philosopher who was the founder of "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0309",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("phenomenology")]), _vm._v(" and a teacher of Martin "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0169"
    }
  }, [_vm._v("Heidegger")]), _vm._v(". Phenomenology is the attempt to develop a philosophy that describes experience as it is lived, prior to any scientific theorizing that grows out of that experience. Husserl taught that "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0073"
    }
  }, [_vm._v("consciousness")]), _vm._v(" is “intentional” and that it can be described both with respect to its subjective act and with respect to the object of its intention, both of which are present in a unified way in experience. There is an irony present in Husserl’s project: whereas his major passion was to make philosophy a rigorous science that would allow it to become a foundational discipline for all the other sciences, his major influence has been on existentialist and poststructuralist philosophers who reject that ideal and think of philosophy as hermeneutical. ("), _c('em', [_vm._v("See")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0137"
    }
  }, [_vm._v("existentialism")]), _vm._v("; "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0172"
    }
  }, [_vm._v("hermeneutics")]), _vm._v("; "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0382",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("structuralism")]), _vm._v(".)")]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "Letter_I"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/toc"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse",
    attrs: {
      "id": "P0184"
    }
  }, [_c('strong', [_vm._v("I-thou relationship.")]), _vm._v(" Martin "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0042"
    }
  }, [_vm._v("Buber’s")]), _vm._v(" term for a special relationship that is possible between persons when those persons relate to each other in a fully personal way and do not think of the other as an object to be manipulated or as a means to an end. Buber believed that such relationships make possible a different kind of knowledge of the other and that it is possible to have such a relation with God, who is the absolute Thou.")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0185"
    }
  }, [_c('strong', [_vm._v("Ibn Rushd.")]), _vm._v(" "), _c('em', [_vm._v("see")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0031"
    }
  }, [_vm._v("Averroës")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0186"
    }
  }, [_c('strong', [_vm._v("Ibn Sina, Abu Ali.")]), _vm._v(" "), _c('em', [_vm._v("see")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0032"
    }
  }, [_vm._v("Avicenna")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0187"
    }
  }, [_c('strong', [_vm._v("icons.")]), _vm._v(" Images of Christ and the saints often found in Eastern Orthodox churches. The term is also used in a broader sense to designate the capacity of human beings to image God and to become images of Christ. "), _c('em', [_vm._v("See also")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0190"
    }
  }, [_vm._v("image of God")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0188"
    }
  }, [_c('strong', [_vm._v("idealism.")]), _vm._v(" In "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0311",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("philosophy")]), _vm._v(", a system of thought that takes Mind or Ideas to be ultimate reality, often denying the reality of the physical world as physical altogether or assigning material reality a lesser status. Examples include the following: George "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0038"
    }
  }, [_vm._v("Berkeley’s")]), _vm._v(" phenomenalism, which views material objects as collections of mental sensations; G. W. F. "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0168"
    }
  }, [_vm._v("Hegel’s")]), _vm._v(" philosophy of Spirit, which views the whole of reality as the expression of an Absolute Mind; and "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0315",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Plato’s")]), _vm._v(" hierarchical view of reality, which views the Forms or Ideas as ultimately real and the material objects as comprising a less real “copy” of the Ideal world. In nonphilosophical contexts, "), _c('em', [_vm._v("idealism")]), _vm._v(" often refers to any movement with high ideals—a movement that is intent on improving the world and believes in that possibility.")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0189"
    }
  }, [_c('strong', [_vm._v("identity, personal.")]), _vm._v(" That which makes a person to be numerically the same individual over time. Theories of personal identity divide into three kinds: (1) psychological theories, which hold that memory or some other psychological continuity constitutes personal identity; (2) bodily theories, which hold that having the same body makes a person to be identical; and (3) nonreductionist theories, which hold that personal identity is either something ultimate and unanalyzable or else that it is grounded in a nonphysical "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0363",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("self")]), _vm._v(" that is similarly ultimate. This philosophical debate has direct implications for the possibility of life after death in various forms, such as disembodied "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0192"
    }
  }, [_vm._v("immortality")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0342",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("reincarnation")]), _vm._v(" and "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0346",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("resurrection")]), _vm._v(" of the body. "), _c('em', [_vm._v("See also")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0308",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("personhood")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0190"
    }
  }, [_c('strong', [_vm._v("image of God.")]), _vm._v(" The unique aspects of human persons that allow them to mirror God. This concept is derived from Genesis 1:26, in which Adam and Eve are described as created in the image of God. Theologians have debated whether the image of God has been lost or merely damaged by "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0367",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("sin")]), _vm._v(". They have debated, in addition, whether the image consists of a set of properties (such as rationality and the capacity for responsible action) or is rather to be seen in our relationality (since the Genesis passage links the image of God to being created male and female) or perhaps even consists of our special relation to God.")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0191"
    }
  }, [_c('strong', [_c('em', [_vm._v("imago Dei.")])]), _vm._v(" "), _c('em', [_vm._v("See")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0190"
    }
  }, [_vm._v("image of God")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0192"
    }
  }, [_c('strong', [_vm._v("immortality.")]), _vm._v(" That which exists forever or (more loosely) that which has no end. Most theologians think that only God is immortal in the sense of having no beginning or end, though many understand God’s immortality not as being temporally everlasting but as being outside "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0400",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("time")]), _vm._v(" altogether. Many religions (and philosophers such as "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0315",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Plato")]), _vm._v(") have believed that humans are immortal in the sense of having no end because they have immaterial souls that survive the death of the body. Christians do not necessarily accept the Platonic view that human souls are intrinsically immortal, but many have thought that the human "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0376",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("soul")]), _vm._v(" does continue to exist between death and the "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0346",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("resurrection")]), _vm._v(" by virtue of God’s power. On this view, humans have a kind of conditional immortality that is dependent on God. "), _c('em', [_vm._v("See also")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0129"
    }
  }, [_vm._v("eternity/everlasting")]), _vm._v("; "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0401",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("timelessness")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0193"
    }
  }, [_c('strong', [_vm._v("immutability.")]), _vm._v(" The "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0107"
    }
  }, [_vm._v("divine attribute")]), _vm._v(" of being unchangeable. Many classical theists have held that God’s immutability is strict and absolute, since God is atemporal. More recently, some who accept the idea of God as everlasting have argued that although God’s basic character and nature do not change, God’s experiences are successive and thus God can experience change. ("), _c('em', [_vm._v("See")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0129"
    }
  }, [_vm._v("eternity/everlasting")]), _vm._v("; "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0401",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("timelessness")]), _vm._v(".) More radically still, some process theologians hold that God’s own nature is evolving. ("), _c('em', [_vm._v("see")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0328",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("process theology")]), _vm._v(".)")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0194"
    }
  }, [_c('strong', [_vm._v("impassibility.")]), _vm._v(" The attribute of God’s being unaffected by anything outside of himself. Those who accept the view that God is impassible hold that he cannot be caused to do or feel anything, because of his "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0283",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("omnipotence")]), _vm._v(" and "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0306",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("perfection")]), _vm._v(". Critics believe that impassibility would be a barrier to genuine loving relations between God and his creatures. "), _c('em', [_vm._v("See also")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0107"
    }
  }, [_vm._v("divine attributes")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0195"
    }
  }, [_c('strong', [_vm._v("incarnation.")]), _vm._v(" Literally, “enfleshment” or “embodiment.” In Christian "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0397",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("theology")]), _vm._v(" this term refers to the act whereby God became human in the person of Jesus of Nazareth. The incarnation is logically tied to the doctrine of the "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0410",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Trinity")]), _vm._v(", as it is God the Son—the second person of the Trinity—who “emptied himself” and became human. ("), _c('em', [_vm._v("see")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0218"
    }
  }, [_vm._v("kenotic theories")]), _vm._v(".) The incarnation received a classical formulation at the Council of Chalcedon (451), which said that in becoming human God the Son remained “one person” but had “two natures” (divine and human). "), _c('em', [_vm._v("See also")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0058"
    }
  }, [_vm._v("Christology")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0196"
    }
  }, [_c('strong', [_vm._v("incorporeality.")]), _vm._v(" The attribute of having no body. Classical Christian theology holds this to be one of the "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0107"
    }
  }, [_vm._v("divine attributes")]), _vm._v(". Some thinkers believe that it is a property of "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0013"
    }
  }, [_vm._v("angels")]), _vm._v(" as well. Incorporeality is compatible with the temporary assumption of a bodily appearance, as in the Old Testament theophanies in which God appeared to Abraham and others. Those who hold this to be an essential divine attribute have adopted a variety of explanations as to how the "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0195"
    }
  }, [_vm._v("incarnation")]), _vm._v(" is possible.")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0197"
    }
  }, [_c('strong', [_vm._v("inductive reasoning.")]), _vm._v(" In a strict sense, reasoning to a generalization on the basis of particular instances of that generalization. An example would be the following: “This swan is white; the next swan is white; and so is the next one. Therefore swans are white.” With the exception of mathematical induction, where the premises of the argument do necessarily imply their conclusion, inductive arguments do not lead to certainty. In a broader sense, inductive reasoning is any form of reasoning in which the conclusion is not logically entailed by the premises (or in other words, any form of reasoning other than deductive reasoning). Inferences from effect to cause or from cause to effect, and probabilistic inferences in general, are inductive arguments. "), _c('em', [_vm._v("See also")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0092"
    }
  }, [_vm._v("deductive argument")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0198"
    }
  }, [_c('strong', [_vm._v("ineffability.")]), _vm._v(" That which cannot be expressed in intelligible language. Many mystics have claimed that an experience of God is ineffable (though that has not stopped them from attempting to describe the experience). "), _c('em', [_vm._v("See also")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0261",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("mysticism")]), _vm._v("; "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0344",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("religious experience")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0199"
    }
  }, [_c('strong', [_vm._v("inerrancy.")]), _vm._v(" The doctrine that the Bible is completely trustworthy and contains no errors. The doctrine is normally qualified in a number of ways. The Bible is said to be inerrant in the original autographs, and it is said to be without error only when properly interpreted. Proper interpretation itself requires attention to genre (such as poetry, proverbs and history) and answers to questions about the intentions of the author and conventions shared by author and reader. Some Christians affirm a limited inerrancy, declaring that the lack of error holds only for certain types of truth that God intends to reveal through Scripture, primarily matters of morality and theology. "), _c('em', [_vm._v("See also")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0200"
    }
  }, [_vm._v("infallibility")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0200"
    }
  }, [_c('strong', [_vm._v("infallibility.")]), _vm._v(" The characteristic of being completely trustworthy, incapable of erring or failing to accomplish an intended purpose. Protestants normally apply this characteristic to the Bible; Catholics extend infallibility to the "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0239",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("magisterium")]), _vm._v(" (teaching authority) of the church. If one assumes that a purpose of the Bible is to communicate revealed truth, then infallibility logically implies at least limited "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0199"
    }
  }, [_vm._v("inerrancy")]), _vm._v(". Nevertheless, in practice some theologians affirm the infallibility but not the inerrancy of the Scriptures, intending thereby to indicate that the Bible can be relied on as an "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0029"
    }
  }, [_vm._v("authority")]), _vm._v(" in matters of faith and practice while recognizing the possibility of scientific and historical errors.")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0201"
    }
  }, [_c('strong', [_vm._v("inference to the best explanation.")]), _vm._v(" Type of reasoning in which the truth of a theory or proposition is affirmed on the grounds that it best accounts for all of the available evidence. This type of inference is sometimes called “abduction” by those who think it is a type of reasoning distinct from induction and deduction. ("), _c('em', [_vm._v("see")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0092"
    }
  }, [_vm._v("deductive argument")]), _vm._v("; "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0197"
    }
  }, [_vm._v("inductive reasoning")]), _vm._v(".) Inference to the best explanation is common in daily life, the detective story and science. Advocates of "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0086"
    }
  }, [_vm._v("cumulative case")]), _vm._v(" apologetics typically appeal to this kind of argument pattern in arguing for the existence of God.")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0202"
    }
  }, [_c('strong', [_vm._v("infinity.")]), _vm._v(" The characteristic of having no bounds or limits. In classical theism, many of God’s attributes, such as knowledge, power and love, are viewed as infinite. ("), _c('em', [_vm._v("See")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0027"
    }
  }, [_vm._v("attributes of God")]), _vm._v(".) In set theory, "), _c('em', [_vm._v("infinite")]), _vm._v(" is often defined as the property of a set that has a subset whose members can be placed in a one-to-one correspondence with the original set, as is the case for the natural numbers and the even integers. With respect to a series, there is debate among philosophers as to whether an actual infinite is possible, as opposed to a procedure that can in principle be repeated endlessly. Those who deny an actual infinite must also deny that the universe is infinitely old.")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0203"
    }
  }, [_c('strong', [_vm._v("inspiration.")]), _vm._v(" The characteristic of being filled and led by the Spirit of God. Thus the Old Testament prophets are regarded as having spoken by inspiration. Many Christian theologians claim that the Bible is the result of divine inspiration as well, adding that this is the reason it is inerrant or infallible. ("), _c('em', [_vm._v("see")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0199"
    }
  }, [_vm._v("inerrancy")]), _vm._v("; "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0200"
    }
  }, [_vm._v("infallibility")]), _vm._v(".) The relation between divine inspiration and the human authorship of the Bible has been variously conceived, but generally an affirmation of inspiration is not intended to deny that the human characteristics of the authors shaped the text in various ways.")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0204"
    }
  }, [_c('strong', [_vm._v("intelligent design.")]), _vm._v(" The scientific hypothesis that the natural order contains a type of complexity that requires an intelligent designer as a cause. Such advocates of intelligent design as Philip Johnson, Michael Behe and William Dembski think that intelligent design is a concept that can support an empirical research program. The intelligent design movement is not necessarily committed to young-earth "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0084"
    }
  }, [_vm._v("creationism")]), _vm._v(" and does not insist from a scientific perspective that the hypothesized designer must be identical with the God of the Bible. "), _c('em', [_vm._v("See also")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0090"
    }
  }, [_vm._v("Darwinism")]), _vm._v("; "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0135"
    }
  }, [_vm._v("evolution, theory of")]), _vm._v("; "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0391",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("teleological argument")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0205"
    }
  }, [_c('strong', [_vm._v("Irenaeus (c. 130-200).")]), _vm._v(" A church father who wrote in Greek against the Gnostic heresies of the day. ("), _c('em', [_vm._v("See")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0160"
    }
  }, [_vm._v("Gnosticism")]), _vm._v(".) Irenaeus is known for his argument that Christ came to actualize all those perfections that God had intended humans to have but that were lost through the sin of Adam and Eve. ("), _c('em', [_vm._v("See")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0140"
    }
  }, [_vm._v("Fall, the")]), _vm._v(".) He is also known for having inspired a “soul-making” "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0396",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("theodicy")]), _vm._v(", which justifies suffering as part of the process whereby humans become all they can be.")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0206"
    }
  }, [_c('strong', [_vm._v("Islam.")]), _vm._v(" Monotheistic religion that originated in what is today Saudi Arabia in the seventh century as a result of the prophetic teachings of Muhammad, recorded in the Qur’an. Islam emphasizes submission to Allah (God) and accepts "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0210"
    }
  }, [_vm._v("Judaism")]), _vm._v(" and Christianity as partially true, grounded in earlier revelations from God. In the medieval period Islam provided a congenial environment for the "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0312",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("philosophy of religion")]), _vm._v(". "), _c('em', [_vm._v("See also")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0207"
    }
  }, [_vm._v("Islamic philosophy")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0207"
    }
  }, [_c('strong', [_vm._v("Islamic philosophy.")]), _vm._v(" The intellectual product of Islamic thinkers such as al-Farabi, "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0032"
    }
  }, [_vm._v("Avicenna")]), _vm._v(" and "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0031"
    }
  }, [_vm._v("Averroës")]), _vm._v(", who creatively synthesized the monotheistic faith of the Qur’an with the Greek philosophical thought of "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0315",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Plato")]), _vm._v(" and "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0022"
    }
  }, [_vm._v("Aristotle")]), _vm._v(" in the early Middle Ages. These thinkers grappled with such questions as the nature of "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0082"
    }
  }, [_vm._v("creation")]), _vm._v(" and the relation of God to the world and the compatibility of human freedom and divine "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0377",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("sovereignty")]), _vm._v(". "), _c('em', [_vm._v("See also")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0206"
    }
  }, [_vm._v("Islam")]), _vm._v(".")]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "Letter_J"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/toc"
    }
  }, [_vm._v("J")])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse",
    attrs: {
      "id": "P0208"
    }
  }, [_c('strong', [_vm._v("Jainism.")]), _vm._v(" One of the religions of India, distinguished from "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0175"
    }
  }, [_vm._v("Hinduism")]), _vm._v(" by its refusal to accept the Brahmanic Vedas as authoritative. Jainism grew out of the teachings of Mahavira, a fifth-century "), _c('span', {
    staticClass: "small"
  }, [_vm._v("B.C.")]), _vm._v(" contemporary of Gautama (the Buddha). It is distinguished by its emphasis on asceticism and commitment to the principle of harmlessness.")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0209"
    }
  }, [_c('strong', [_vm._v("James, William (1842-1910).")]), _vm._v(" American philosopher and psychologist and one of the originators of "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0323",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("pragmatism")]), _vm._v(". In "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0312",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("philosophy of religion")]), _vm._v(" James is known for his argument in “The Will to Believe” that "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0139"
    }
  }, [_vm._v("faith")]), _vm._v(" can be reasonable even if it is not supported by the preponderance of evidence. ("), _c('em', [_vm._v("See")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0424",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("will to believe")]), _vm._v(".) He is known as well for his astute descriptions of the religious life in "), _c('em', [_vm._v("The Varieties of Religious Experience.")])]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0210"
    }
  }, [_c('strong', [_vm._v("Judaism.")]), _vm._v(" The religion of the Jewish people that takes the Hebrew Bible (regarded by Christians as the Old Testament) as authoritative. Judaism exists in various forms—Orthodox, Conservative and Reformed—and each form interprets biblical "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0029"
    }
  }, [_vm._v("authority")]), _vm._v(" somewhat differently. This religion takes as its starting point the special vocation of the Jewish people, called out of Egypt and led by Moses, as those to whom God’s law was given. Judaism has nurtured a centuries-old tradition in "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0311",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("philosophy")]), _vm._v(", ranging from Philo in the first century through such medieval thinkers as Moses "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0240",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Maimonides")]), _vm._v(" to many distinguished contemporary Jewish philosophers.")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0211"
    }
  }, [_c('strong', [_vm._v("judgment, last.")]), _vm._v(" Final assessment by God of the works and "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0056"
    }
  }, [_vm._v("character")]), _vm._v(" of humans. Christians believe that the saving work of Christ provides the only hope for humans to stand in the day of judgment. "), _c('em', [_vm._v("See also")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0347",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("retribution")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0212"
    }
  }, [_c('strong', [_vm._v("just war theory.")]), _vm._v(" The ethical theory that Christians may legitimately fight in wars, but only when certain conditions are met. Those conditions include the following: the cause must be just; the war must be waged by a legitimate government; the means used must be moral; the war must be a last resort; and there must be a reasonable chance of achieving the goals of the war. The just war theory has been the dominant view about participation in war among Catholic, Lutheran and Reformed theologians. It has traditionally been rejected by Mennonites, Quakers and members of other peace churches. Today it is increasingly questioned in the traditions that have nurtured it, especially with respect to the possibility of a nuclear conflict. "), _c('em', [_vm._v("See also")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0292",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("pacifism")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0213"
    }
  }, [_c('strong', [_vm._v("justice.")]), _vm._v(" Giving people what is due them. As a social ideal, justice is a major concept in political philosophy. Traditional philosophers also saw justice as a personal "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0417",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("virtue")]), _vm._v(" and inquired about the nature of a just person as well as how a person acquires a just "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0056"
    }
  }, [_vm._v("character")]), _vm._v(". In contemporary society there is much dispute about the nature of economic justice, retributive justice and political justice. Theological questions about justice are posed by doctrines such as "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0325",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("predestination")]), _vm._v(" and "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0170"
    }
  }, [_vm._v("hell")]), _vm._v(" understood as eternal punishment.")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0214"
    }
  }, [_c('strong', [_vm._v("justification.")]), _vm._v(" A positive term of appraisal in epistemology, used in a variety of ways. A belief is said to be justified deontologically when the believer has adequately fulfilled his or her epistemic duties in acquiring and maintaining the belief. A belief is said to be justified in a more substantive sense when it is based on a good reason, or has the right kind of ground or foundation, one that makes it likely or more likely that the belief is "), _c('em', [_vm._v("true")]), _vm._v(". Justification in epistemology obviously must be distinguished from justification in theology, where the term refers to God’s action in accepting Jesus’ atonement as sufficient to warrant the acceptance of human beings as righteous even while they are still sinful.")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0215"
    }
  }, [_c('strong', [_vm._v("Justin Martyr (c. 105-c. 165).")]), _vm._v(" One of the early church fathers who saw positive value in philosophy for Christianity. Justin believed that Greek "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0311",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("philosophy")]), _vm._v(" contained truths due to the work of the "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0234"
    }
  }, [_vm._v("Logos")]), _vm._v(" Christ understood as the Creator who works in all people.")]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "Letter_K"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/toc"
    }
  }, [_vm._v("K")])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse",
    attrs: {
      "id": "P0216"
    }
  }, [_c('strong', [_c('em', [_vm._v("kalam")]), _vm._v(" cosmological argument.")]), _vm._v(" Version of the first-cause argument for God’s reality, developed by Islamic thinkers, which claims that the world must have had a beginning and that God must exist as the cause of that beginning. Defended in the twentieth century by William Craig. "), _c('em', [_vm._v("See also")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0079"
    }
  }, [_vm._v("cosmological arguments")]), _vm._v("; "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0207"
    }
  }, [_vm._v("Islamic philosophy")]), _vm._v("; "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0394",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("theistic arguments")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0217"
    }
  }, [_c('strong', [_vm._v("Kant, Immanuel (1724-1804).")]), _vm._v(" One of the greatest modern philosophers, whose critical philosophy attempted to synthesize the insights of both "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0334",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("rationalism")]), _vm._v(" and "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0122"
    }
  }, [_vm._v("empiricism")]), _vm._v(". Kant argued in his "), _c('em', [_vm._v("Critique of Pure Reason")]), _vm._v(" that genuine scientific knowledge is possible but that this knowledge is of “phenomenal” reality—that is, reality as it appears to us, rather than reality as it is in itself. Human knowledge is always structured by space and time, which are the “forms of intuition” of the human mind, and by the categories provided by the human understanding such as causality and substance. As Kant saw it, though traditional "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0264",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("natural theology")]), _vm._v(" is a failure and no theoretical knowledge of God is possible, recognizing the limits of reason allows room for a rational, moral faith. As we strive to live morally in accordance with the "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0051"
    }
  }, [_vm._v("categorical imperative")]), _vm._v(", we must rationally presuppose human freedom, the existence of God and "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0192"
    }
  }, [_vm._v("immortality")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0218"
    }
  }, [_c('strong', [_vm._v("kenotic theories.")]), _vm._v(" Theories of the "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0195"
    }
  }, [_vm._v("incarnation")]), _vm._v(", inspired by Philippians 2:7 (from Greek "), _c('em', [_vm._v("kenoō,")]), _vm._v(" “to empty”) and other New Testament passages, which hold that in becoming human God the Son divested himself (at least temporarily) of some of the "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0107"
    }
  }, [_vm._v("divine attributes")]), _vm._v(", such as "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0283",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("omnipotence")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0285",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("omniscience")]), _vm._v(" and "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0284",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("omnipresence")]), _vm._v(". Kenotic theories of the incarnation have led some to develop kenotic theories of the nature of God, which view the essence of God to be his self-giving love that freely limits itself to allow some "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0030"
    }
  }, [_vm._v("autonomy")]), _vm._v(" to his creation.")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0219"
    }
  }, [_c('strong', [_vm._v("Kierkegaard, Søren (1813-1855).")]), _vm._v(" Danish Christian philosopher and theologian, whose writings contain a stinging critique of G. W. F. "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0168"
    }
  }, [_vm._v("Hegel")]), _vm._v(" and "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0188"
    }
  }, [_vm._v("idealism")]), _vm._v(", "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0227"
    }
  }, [_vm._v("liberal")]), _vm._v(" theology, and the whole culture of Christendom, which assumes that we are all Christians by virtue of being Danes, Americans or whatever. Kierkegaard considered himself to be a missionary whose vocation was to reintroduce Christianity into Christendom. His philosophical work focuses on the nature of human existence, since he thought that Christianity must first be understood as a way of existing but that people have forgotten what it means to exist as a human being. Kierkegaard rejected apologetic attempts to make Christianity appear reasonable, holding that New Testament Christianity must always appear foolish to the worldly mind and that genuine proclamation of the gospel always maintains the possibility of offense. He stressed the qualitative difference between God and human beings and viewed the "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0195"
    }
  }, [_vm._v("incarnation")]), _vm._v(" as an absolute paradox that human "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0336",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("reason")]), _vm._v(" cannot understand but can only believe in "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0139"
    }
  }, [_vm._v("faith")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0220"
    }
  }, [_c('strong', [_vm._v("knowledge.")]), _vm._v(" True "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0037"
    }
  }, [_vm._v("belief")]), _vm._v(" that is warranted or justified. A person cannot know what is false, but a mere true belief that is the result of luck or guessing does not appear to constitute knowledge either. Most philosophers therefore agree that knowledge requires a true belief that is justified or warranted or that has been acquired through a reliable process, though there is great disagreement as to what it is that warrants or justifies a belief.")]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "Letter_L"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/toc"
    }
  }, [_vm._v("L")])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse",
    attrs: {
      "id": "P0221"
    }
  }, [_c('strong', [_vm._v("language, religious (theories of).")]), _vm._v(" Accounts of how human language can be used meaningfully to refer to and communicate information about a transcendent God. In the medieval period thinkers developed subtle theories of analogy. ("), _c('em', [_vm._v("See")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0009"
    }
  }, [_vm._v("analogical predication")]), _vm._v(".) In the mid-twentieth century "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0233"
    }
  }, [_vm._v("logical positivists")]), _vm._v(" challenged the cognitive meaningfulness of religious language and inspired a debate about the verifiability or falsifiability of such language. In the last half of the twentieth century Ludwig "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0425",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wittgenstein’s")]), _vm._v(" work on “language games” attracted much attention to the unique character of religious language and its relation to various forms of life.")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0222"
    }
  }, [_c('strong', [_vm._v("law (moral, divine, natural).")]), _vm._v(" A rule prescribed by a controlling "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0029"
    }
  }, [_vm._v("authority")]), _vm._v(". The laws of a state or nation typically regulate conduct or behavior. Believers in God typically think of laws in several distinct, though overlapping, senses. The divine law represents God’s governing decrees, at least some of which may be knowable only through a "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0378",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("special revelation")]), _vm._v(" from God. Those who accept a "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0108"
    }
  }, [_vm._v("divine command")]), _vm._v(" theory of "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0259",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("morality")]), _vm._v(" will typically think of the moral law as part of the divine law, with disagreements as to whether the moral law can be known independently of special revelation. Others, particularly nontheists, may use the expression “moral law” metaphorically, to indicate the lawlike force of moral obligations, even though these obligations are not literally issued as laws. The term “natural law” is used to indicate a moral law that God has instituted by virtue of creating the world with particular structures and purposes; to act morally is to act in accord with nature, in ways that respect the natural functions of things. Typically those who affirm "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0262",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("natural law")]), _vm._v(" in this sense think of such principles as things that can be ascertained apart from special revelation. “Natural law” in this sense should be distinguished from “laws of nature” understood as scientific or physical laws. Again, theists may think of scientific laws as representing God’s ordered rule of creation, while nontheists may use the expression “law” here metaphorically to indicate the regular, lawlike order that "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0359",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("science")]), _vm._v(" discovers, without necessarily attributing that order to any intentional design.")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0223"
    }
  }, [_c('strong', [_vm._v("Leibniz, Gottfried (1646-1716).")]), _vm._v(" German rationalist philosopher who taught that reality is composed of monads—simple substances that have no spatial extension. God is the supreme monad and creates and conserves all other monads. Monads do not really interact with each other but appear to do so due to the “pre-established harmony” that God ordains. Leibniz argued that God could have created any possible world. Because God is perfect, Leibniz concluded that the actual world must be the best possible world. In addition to his many contributions to logic, Leibniz invented calculus (simultaneously with Newton). "), _c('em', [_vm._v("See also")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0334",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("rationalism")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0224"
    }
  }, [_c('strong', [_vm._v("Lessing, Gotthold (1729-1781).")]), _vm._v(" German philosopher, literary author and critic who developed a historical conception of religion and religious "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0411",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("truth")]), _vm._v(". For Lessing, the great world religions are primarily way stations in the ethical progress of humankind; none is absolutely true. He is famous for his conception of the “ugly, wide ditch” between “eternal truths of reason” and the truths of history. He argued that this logical gap makes it impossible to embrace the historical claims of Christianity with the kind of certainty religion demands. "), _c('em', [_vm._v("See also")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0334",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("rationalism")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0225"
    }
  }, [_c('strong', [_vm._v("Levinas, Emmanuel (1906-1995).")]), _vm._v(" Jewish philosopher who spent his career in France, though born in Lithuania. Levinas is distinguished by his emphasis on "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0130"
    }
  }, [_vm._v("ethics")]), _vm._v(" as “first philosophy” and by his claim that ethics is grounded in a direct experience of the “gaze of the other” rather than theory. Levinas taught that true religion grows out of this same encounter with the Other, in which we discover a God who cannot be viewed as an object.")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0226"
    }
  }, [_c('strong', [_vm._v("Lewis, C. S. (1898-1963).")]), _vm._v(" Belfast-born English literary critic, novelist and Christian apologist. The popularity and simplicity of Lewis’s philosophical "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0019"
    }
  }, [_vm._v("apologetics")]), _vm._v(" belie the intellectual depth of his work. His "), _c('em', [_vm._v("Mere Christianity")]), _vm._v(" is probably the most successful work of Christian apologetics of the twentieth century, and his Narnia books are beloved by children and adults for their wonderful blend of charm, fantasy and theological insight. Lewis grappled with the problem of "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0133"
    }
  }, [_vm._v("evil")]), _vm._v(" in "), _c('em', [_vm._v("The Problem of Pain")]), _vm._v(" and with supernaturalism in "), _c('em', [_vm._v("Miracles.")]), _vm._v(" "), _c('em', [_vm._v("The Abolition of Man")]), _vm._v(" focuses on the importance of emotion and objective moral truths to our understanding of human nature. "), _c('em', [_vm._v("See also")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0246",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("mere Christianity")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0227"
    }
  }, [_c('strong', [_vm._v("liberalism (theological).")]), _vm._v(" Movement in Protestant "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0397",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("theology")]), _vm._v(" since the nineteenth century that is dominated by the goal of modifying Christianity so as to make it consistent with modern culture and science. Liberalism rejects the traditional view of Scripture as an authoritative propositional "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0348",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("revelation")]), _vm._v(" from God in favor of a view that sees revelation as a record of the evolving "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0344",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("religious experiences")]), _vm._v(" of humankind. It sees Jesus more as ethical teacher and model rather than as divine atoner and redeemer.")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0228"
    }
  }, [_c('strong', [_vm._v("liberation theology.")]), _vm._v(" A theological movement that developed in Latin America in the 1960s, emphasizing the gospel as a power that liberates oppressed peoples from unjust economic, political and social structures. Liberation theology is rooted in the special concern the Bible shows for the poor, but it has created controversy by sometimes relying on Marxist-inspired analyses of the causes of poverty and oppression. "), _c('em', [_vm._v("See also")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0213"
    }
  }, [_vm._v("justice")]), _vm._v("; "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0244",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Marxism")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0229"
    }
  }, [_c('strong', [_vm._v("libertarianism (metaphysical).")]), _vm._v(" In "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0130"
    }
  }, [_vm._v("ethics")]), _vm._v(" and "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0249",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("metaphysics")]), _vm._v(", the view that human beings sometimes can will more than one possibility. According to this view, a person who freely made a particular choice could have chosen differently, even if nothing about the past prior to the moment of choice had been different. Libertarianism therefore rejects the "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0068"
    }
  }, [_vm._v("compatibilist")]), _vm._v(" view that "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0151"
    }
  }, [_vm._v("free will")]), _vm._v(" and "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0101"
    }
  }, [_vm._v("determinism")]), _vm._v(" are consistent.")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0230"
    }
  }, [_c('strong', [_vm._v("libertarianism (political).")]), _vm._v(" In political philosophy, the view that individual human freedom is a primary value and that government restrictions on that freedom should be limited to what is necessary for the maintenance of a society that is conducive to freedom. Thus libertarianism offers a justification of state power over against anarchism, but it holds that there is moral justification only for a minimal state sufficient to defend citizens against attack and protect against crime.")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0231"
    }
  }, [_c('strong', [_vm._v("life after death.")]), _vm._v(" The continuation of conscious personal existence after death. Traditionally, most Christians have taught that the hope for life after death rests on God’s promise of the resurrection of the body, though personal existence continues between death and the resurrection in some “intermediate state,” in which those who are saved are with God. Such a view implies the existence of a soul that is separable from the body. In the twentieth century some theologians have argued that Christians should take a “physicalist” view of the human person that identifies the person and the body. Such a view is incompatible with an intermediate state and faces a problem: how is the resurrected bodily person identical to the person who died when there is no soul to provide that identity?")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0232"
    }
  }, [_c('strong', [_vm._v("Locke, John (1632-1704).")]), _vm._v(" English philosopher who defended "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0122"
    }
  }, [_vm._v("empiricism")]), _vm._v(" in "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0124"
    }
  }, [_vm._v("epistemology")]), _vm._v(" and a social contract theory of the state. Locke—one of the founders of modern "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0311",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("philosophy")]), _vm._v(" put forward an empiricist epistemology partly as a way of trying to resolve and control bloody religious conflicts. He defended an ethic that requires humans to inspect their "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0037"
    }
  }, [_vm._v("beliefs")]), _vm._v(" and try to ensure that they are holding those beliefs with a degree of confidence proportional to the evidence on which they are based. Locke thought that his epistemology could support a reasonable form of Christianity while limiting what he called “enthusiasm.” His political thinking stressed the idea that the state is based on a social contract with the citizens and can therefore lose legitimacy if that contract is undermined. This idea was influential on the founding fathers of the United States.")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0233"
    }
  }, [_c('strong', [_vm._v("logical positivism.")]), _vm._v(" Philosophical movement arising out of the Vienna Circle of philosophers in Austria after World War I. Logical positivism combined the commitment to "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0122"
    }
  }, [_vm._v("empiricism")]), _vm._v(" found in nineteenth-century positivism (Comte) with the type of logical analysis found in the work of Bertrand "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0353",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Russell")]), _vm._v(". It affirmed a verifiability theory of meaning, in which nonanalytic propositions have "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0062"
    }
  }, [_vm._v("cognitive")]), _vm._v(" meaning only if they are empirically verifiable. On the basis of this theory, logical positivists asserted metaphysical and theological propositions to be meaningless, and they analyzed ethical propositions as merely having expressive meaning. "), _c('em', [_vm._v("See also")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0221"
    }
  }, [_vm._v("language, religious (theories of")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0234"
    }
  }, [_c('strong', [_vm._v("Logos.")]), _vm._v(" Greek term for “Word” or “Reason,” used in the prologue to John’s Gospel: “In the beginning was the Word.” The "), _c('em', [_vm._v("Logos")]), _vm._v(" is thus a term for the eternal Son of God, the second person of the "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0410",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Trinity")]), _vm._v(", understood as the agent of divine "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0082"
    }
  }, [_vm._v("creation")]), _vm._v(" and the one who “illumines,” or enlightens, human beings. Many early church fathers used this concept to justify a positive attitude toward Greek "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0311",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("philosophy")]), _vm._v(" on the grounds that those who lacked the biblical "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0348",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("revelation")]), _vm._v(" could still attain some truth because of the operation of Christ as the Logos in them.")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0235"
    }
  }, [_c('strong', [_vm._v("love.")]), _vm._v(" The heart of God’s character and, along with "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0139"
    }
  }, [_vm._v("faith")]), _vm._v(" and "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0180"
    }
  }, [_vm._v("hope")]), _vm._v(", one of the cardinal "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0417",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("virtues")]), _vm._v(", according to Christianity. Christian theologians often distinguish among different forms of love: erotic love, friendship love and the love for neighbor that most closely resembles God’s self-giving love in Jesus, who came down from heaven and sacrificed his life for humans who were in rebellion against God. "), _c('em', [_vm._v("See also")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0006"
    }
  }, [_vm._v("agapism")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "verse",
    attrs: {
      "id": "P0236"
    }
  }, [_c('strong', [_vm._v("Luther, Martin (1483-1546).")]), _vm._v(" German theologian and father of the Protestant Reformation. The heart of Luther’s understanding of the gospel stressed that "), _c('span', {
    attrs: {
      "href": "#/Text/M2Z#P0354",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("salvation")]), _vm._v(" was a free work of "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0164"
    }
  }, [_vm._v("grace")]), _vm._v(" that is grasped through "), _c('a', {
    attrs: {
      "href": "#/Text/A2L#P0139"
    }
  }, [_vm._v("faith")]), _vm._v(". Persons are not saved because of any merits they may possess but because the work of Christ is imputed to them by God.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-608979ea","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/A2L.vue
// module id = 69
// module chunks = 0